// Español neutro de Latinoamérica: "tú", "video" (sin tilde), sin modismos locales.
export default {
  languages: {
    English: 'Inglés',
    Spanish: 'Español',
    Portuguese: 'Portugués',
    French: 'Francés',
    German: 'Alemán',
    Italian: 'Italiano',
    Arabic: 'Árabe',
    Russian: 'Ruso',
    Japanese: 'Japonés',
    Korean: 'Coreano',
    Hindi: 'Hindi',
    Chinese: 'Chino',
    Bengali: 'Bengalí',
    Indonesian: 'Indonesio',
    Turkish: 'Turco',
    Urdu: 'Urdu',
    Tamil: 'Tamil',
    Persian: 'Persa',
    Romanian: 'Rumano',
    Filipino: 'Filipino',
    Kazakh: 'Kazajo',
  },

  styles: {
    realistic: { label: 'Realista', description: 'Estilo detallado y fiel a la realidad' },
    cinematic: { label: 'Cinematográfico', description: 'Escenas dramáticas, como de película' },
    '3d-animation': { label: 'Cartoon 3D', description: 'Look de película animada en 3D, en imágenes' },
    cartoon: { label: 'Dibujo animado', description: 'Contornos marcados, colores planos y vivos' },
    'comic-book': { label: 'Cómic', description: 'Tinta y tramas, como una novela gráfica' },
    storybook: { label: 'Cuento ilustrado', description: 'Ilustración cálida de libro infantil' },
    'anime-realism': { label: 'Anime realista', description: 'Anime crudo y realista' },
    anime: { label: 'Anime', description: 'Estilo japonés con ojos expresivos' },
    'dreamy-anime': { label: 'Anime de ensueño', description: 'Anime pintado a mano, frondoso y cálido' },
    'oil-portrait': { label: 'Retrato al óleo', description: 'Estilo renacentista, texturas ricas' },
    watercolor: { label: 'Acuarela', description: 'Colores pastel, textura de pintura' },
    'ink-sketch': { label: 'Boceto en tinta', description: 'Tinta negra, sombreado cruzado' },
    'pop-art': { label: 'Pop art', description: 'Alto contraste, colores intensos' },
    collage: { label: 'Collage', description: 'Composición artesanal por capas' },
    'paper-cutout': { label: 'Papel recortado', description: 'Capas de papel, formas simples' },
    'ukiyo-e': { label: 'Ukiyo-e', description: 'Grabado japonés en madera' },
    kawaii: { label: 'Kawaii', description: 'Tierno, en colores pastel' },
    claymation: { label: 'Plastilina', description: 'Figuras de plastilina en stop motion' },
    'pixel-art': { label: 'Pixel art', description: 'Píxeles de videojuego retro de 16 bits' },
    'low-poly': { label: 'Low poly', description: '3D facetado, estilo juego indie' },
    'fantasy-epic': { label: 'Fantasía épica', description: 'Magia, castillos, alta fantasía' },
    cyberpunk: { label: 'Cyberpunk', description: 'Luces de neón, ciudad futurista' },
    'vintage-retro': { label: 'Vintage retro', description: 'Inspirado en los 70, 80 y 90, tonos cálidos' },
    'noir-film': { label: 'Cine negro', description: 'Blanco y negro, iluminación dramática' },
    spooky: { label: 'Terror', description: 'Oscuro e inquietante, sombras intensas' },
  },

  // A narrator's voice: a man's or a woman's (i18n/narration.js VOICE_GENDERS)
  voiceGender: {
    man: 'Hombre',
    woman: 'Mujer',
  },
  voices: {
    alloy: 'Neutra y equilibrada, clara y versátil',
    ash: 'Suave y conversacional, de tono cálido',
    ballad: 'Delicada, expresiva y melódica',
    coral: 'Cálida y amigable, de tono medio',
    echo: 'Clara y resonante, algo formal',
    fable: 'Expresiva, ideal para contar historias',
    nova: 'Enérgica, juvenil y brillante',
    onyx: 'Grave, firme y con autoridad',
    sage: 'Tranquila, reflexiva y sabia',
    shimmer: 'Ligera, alegre y entusiasta',
    verse: 'Articulada, de narrador profesional',
    puck: 'Animado y juguetón, ideal para datos curiosos',
    kore: 'Firme y segura, hecha para explicar',
    fenrir: 'Emocionado y rápido, para deportes y emoción',
    aoede: 'Ligera y fresca, para estilo de vida y viajes',
    enceladus: 'Grave y susurrante, para terror y misterio',
    algenib: 'Ronca y dramática, como un tráiler de cine',
    despina: 'Suave y elegante, para lujo y marcas',
    achernar: 'Suave y tranquila, para calma y cuentos para dormir',
    zephyr: 'Brillante y alegre, para niños y tutoriales',
    sadaltager: 'Sabio, como un presentador de documentales',
    zubenelgenubi: 'Casual y relajado, como hablar con un amigo',
    pulcherrima: 'Audaz y directa, para motivación',
  },

  sidebar: {
    label: 'Aplicación',
    home: 'Inicio',
    create: 'Crear',
    fromVideo: 'Desde un video',
    collapse: 'Plegar la barra lateral',
    expand: 'Abrir la barra lateral',
    managePlan: 'Gestionar el plan',
  },
  dashboard: {
    seoTitle: 'Inicio',
    kicker: 'Inicio',
    title: '¿Qué hacemos hoy?',
    titleNamed: '¿Qué hacemos hoy, {name}?',
    subtitle: 'Escribe una idea y el Agente de IA hace el video. O empieza desde un video que ya tienes.',
    placeholder: 'Describe tu video en una frase…',
    make: 'Crear',
    recent: 'Recientes',
    seeAll: 'Ver todo',
    empty: 'Nada todavía. Tu primer video empieza con una frase, arriba.',
    ready: 'Listo',
    making: 'En proceso',
    failed: 'Falló',
    untitled: 'Sin título',
  },
  nav: {
    features: 'Funciones',
    pricing: 'Precios',
    login: 'Iniciar sesión',
    getStarted: 'Empezar',
    getStartedFree: 'Empieza gratis',
    create: 'Crear',
    menu: 'Menú',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    themeSystem: 'Como el dispositivo',
    usage: 'Uso',
    videoMinutes: 'Minutos de video',
    aiAgentVideos: 'Videos del Agente de IA',
    upgrade: 'Mejorar a Pro',
    myAccount: 'Mi cuenta',
    admin: 'Panel de administración',
    logout: 'Cerrar sesión',
    user: 'Usuario',
    tools: 'Herramientas',
    minutesLeft: 'Te quedan {n} minutos de procesamiento de video.',
    minutesUnlimited: 'Tienes minutos de procesamiento ilimitados.',
    agentLeft: 'Te quedan {n} videos del Agente de IA.',
    trialShort: 'Prueba: {n} d',
    trialEnds: 'La prueba termina el {date}',
    trialLeftOne: 'Queda {n} día de prueba',
    trialLeftMany: 'Quedan {n} días de prueba',
    badgeNew: 'Nuevo',
    badgeBeta: 'Beta',
  },
  tools: {
    aiClipping: 'Clips con IA',
    captions: 'Subtítulos',
    reframe: 'Reencuadre',
    editor: 'Editor',
    aiAgent: 'Agente de IA',
  },
  featureLinks: {
    aiClipping: { label: 'Clips con IA', description: 'Convierte videos largos en shorts virales' },
    autoCaption: { label: 'Subtítulos automáticos', description: 'Subtítulos con estilo para cualquier video' },
    reframe: { label: 'Reencuadre con IA', description: 'Adapta videos completos con recorte inteligente' },
    aiAgent: { label: 'Agente de IA', description: 'Crea videos a partir de una idea con IA' },
    editor: { label: 'Editor de video online', description: 'Edición profesional en tu navegador' },
  },
  createActions: {
    aiClipping: { label: 'Clips con IA', description: 'Extrae los mejores momentos de tus videos' },
    autoCaption: { label: 'Subtítulos automáticos', description: 'Agrega subtítulos con estilo a tus videos' },
    reframe: { label: 'Reencuadre de video', description: 'Recorta y adapta el formato con IA' },
    aiAgent: { label: 'Agente de IA', description: 'Crea videos a partir de una idea' },
    scenes: { label: 'Escenas', description: 'Una toma animada con sonido y voces' },
    editor: { label: 'Editor de video', description: 'Edita videos en tu navegador' },
    series: {
      label: 'Series',
      description: 'Videos nuevos en un horario o cuando quieras',
    },
    characters: { label: 'Personajes', description: 'Un elenco que se ve igual en cada video' },
  },

  footer: {
    monetizeGuide: 'Monetizar videos con IA',
    clipYtShorts: 'De YouTube a Shorts',
    clipPodcasts: 'Clips de podcast',
    clipStreams: 'Clips de streams',
    clipClippers: 'Para clippers',
    canalDarkGuide: 'Cómo hacer un canal dark',
    company: 'Empresa',
    about: 'Sobre Clip-Short',
    videoReframe: 'Reencuadre de video',
    videoEditor: 'Editor de video',
    faq: 'Preguntas frecuentes',
    affiliates: 'Programa de afiliados',
    privacy: 'Política de privacidad (en inglés)',
    cookies: 'Preferencias de cookies',
    signUp: 'Regístrate gratis',
    language: 'Idioma',
    copyright: '© {year} Clip-Short.com - Plataforma de video con IA',
    tools: 'Herramientas',
    freeTools: 'Herramientas gratis',
    guides: 'Guías',
    compareUseCases: 'Comparativas y casos de uso',
    characters: 'Personajes',
    remix: 'Remix',
    scenes: 'Escenas',
    yourProjects: 'Tus proyectos',
    account: 'Cuenta',
  },

  consent: {
    title: 'Usamos cookies de analítica y para medir nuestros anuncios',
    allow: 'Aceptar cookies',
    decline: 'Rechazar',
    manage: 'Configurar',
    learnMore: 'Más información en nuestra',
    policy: 'Política de privacidad y cookies',
    dialogTitle: 'Preferencias de privacidad',
    dialogBody: 'Elige qué cookies y almacenamiento opcionales usamos. Los datos esenciales (para iniciar sesión y recordar tus preferencias) siempre están activos.',
    dialogBodyShort: 'Elige las cookies opcionales. Los datos esenciales siempre están activos.',
    analytics: 'Analítica',
    analyticsBody: 'Permite que PostHog y Vercel Speed Insights registren tendencias de uso del producto, y que Google Ads nos diga si un anuncio nuestro te trajo aquí. Nos ayudan a mejorar funciones y rendimiento sin identificarte directamente.',
    analyticsBodyShort: 'Nos ayuda a mejorar funciones y rendimiento, y a medir nuestros anuncios.',
    toggle: 'Activar o desactivar cookies de analítica',
    readMore: 'Consulta cómo usamos las cookies y los datos en nuestra',
    revisit: 'Puedes cambiar esta configuración cuando quieras desde el menú o el aviso de cookies.',
    revisitShort: 'Puedes cambiarla cuando quieras desde el menú.',
    reset: 'Restablecer decisión',
    close: 'Cerrar',
  },

  agentFormats: {
    label: 'Formato',
    story: 'Historia',
    countdown: 'Top 5',
    quiz: 'Quiz / ¿qué prefieres?',
    chat: 'Historia por chat',
    pov: 'POV: estás ahí',
  },
  publish: {
    posted: {
      title: '¿Ya lo publicaste?',
      hint: 'Marca dónde lo publicaste, para llevar la cuenta.',
      seriesHint: 'Marca dónde lo publicaste. La serie inclina sus próximas ideas hacia los episodios que publicas.',
      since: 'Marcado como publicado el {day}',
      failed: 'No se pudo guardar. Inténtalo de nuevo.',
    },
    button: 'Publicar',
    title: 'Publica este video',
    subtitle: 'Textos escritos para cada red en el idioma de tu video. Edítalos, cópialos y publica.',
    platforms: 'Redes',
    writing: 'Escribiendo la publicación…',
    writeFailed: 'No se pudo escribir. Inténtalo de nuevo.',
    copy: 'Copiar texto',
    copied: 'Copiado',
    copyOne: 'Copiar',
    copyAll: 'Copiar todo',
    rewrite: 'Escribir de nuevo',
    write: 'Escribir el texto del post',
    aiLabel: 'En YouTube, activa "Contenido alterado o sintético" si el video muestra personas o hechos realistas hechos con IA.',
    shareToApp: 'Enviar a la app',
    shareGettingReady: 'Preparando el video…',
    shareFailed: 'Tu teléfono no aceptó el video. Guárdalo en tu dispositivo y súbelo desde la app.',
    openPlatform: 'Abrir {platform}',
    scheduleTitle: 'Publicar más tarde',
    scheduleHint: 'Te enviaremos por correo el video y estos textos a esa hora.',
    schedule: 'Recuérdamelo',
    scheduleFailed: 'No se pudo programar. Elige una hora dentro de los próximos 60 días.',
    cancel: 'Cancelar',
    platform: {
      tiktok: 'TikTok',
      youtube: 'YouTube Shorts',
      instagram: 'Instagram Reels',
      facebook: 'Facebook Reels',
    },
    fields: {
      title: 'Título',
      description: 'Descripción',
      caption: 'Descripción',
      tags: 'Etiquetas',
    },
    shareSubtitle: 'Textos para cada plataforma, un recordatorio para más tarde y un enlace que cualquiera puede abrir.',
  },
  usageLimit: {
    title: "Llegaste al límite de este mes",
    minutes: "Usaste los minutos de video de este periodo.",
    aiVideos: "Usaste los videos con IA de este periodo.",
    upgrade: "Un plan más grande te da más cada mes.",
    close: "Cerrar",
    pricing: "Ver planes",
  },
  translateVideo: {
    versions: "En otros idiomas:",
    original: "Ver el original",
    translating: "Traduciendo…",
    button: 'Traducir',
    title: 'Hazlo en otro idioma',
    subtitle: 'Las mismas imágenes, con la narración y los textos traducidos y narrados de nuevo con la misma voz.',
    costsOne: 'Es un video nuevo, así que usa uno de los videos de IA de tu plan.',
    make: 'Hacer el video',
    failed: 'No se pudo empezar la traducción. Inténtalo de nuevo.',
    outOfVideos: "No te quedan videos de IA. Mejora tu plan para hacer más.",
  },
  // Your own voice (components/voices, api/services/voices.py)
  ownVoice: {
    group: 'Tus voces',
    record: 'Graba tu voz',
    recordHint: 'Narra tus videos con tu propia voz',
    paidOnly: 'Tu propia voz está en los planes de pago',
    upgrade: 'Ver planes',
    slow: 'Tu propia voz tarda más: unos 5 minutos por minuto de narración, en videos de hasta {minutes} minutos.',
    tooLong: 'Tu propia voz narra videos de hasta {minutes} minutos. Elige una duración más corta u otra voz.',
    play: 'Escuchar {name}',
    sampleMaking: 'Preparando una muestra con esta voz…',
    dialog: {
      title: 'Graba tu voz',
      subtitle: 'Lee una frase en voz alta y con ella hacemos tu voz. Puede narrar tus videos en español, inglés, portugués, árabe y más.',
      ownOnly: 'Graba solo tu propia voz. La frase que lees es tu autorización y trae palabras nuevas cada vez, así que no sirve la grabación de otra persona.',
      language: 'El idioma en que vas a leer',
      name: 'Nombre (opcional)',
      namePlaceholder: 'Mi voz',
      getSentence: 'Muéstrame la frase',
      readThis: 'Lee esto en voz alta, con tu voz de siempre:',
      start: 'Empezar a grabar',
      stop: 'Detener',
      recording: 'Grabando… {seconds} s',
      again: 'Grabar de nuevo',
      save: 'Guardar mi voz',
      saving: 'Revisando tu grabación…',
      saved: 'Tu voz está lista. Elígela como narrador.',
      tips: 'Un cuarto en silencio, el teléfono o micrófono a un palmo, de 10 a 20 segundos.',
    },
    errors: {
      microphone: 'No pudimos usar tu micrófono. Permítelo en el navegador y vuelve a intentarlo.',
      micBlocked: 'Tu navegador bloqueó el micrófono. Permítelo para clip-short.com (el icono al inicio de la barra de direcciones) y vuelve a intentarlo.',
      micBlockedIos: 'Tu iPhone bloqueó el micrófono. En Safari: toca el menú de la página en la barra de direcciones, luego Configuración del sitio web y Micrófono: Permitir. En Chrome: abre la app Ajustes, luego Chrome, y activa Micrófono. Después vuelve a intentarlo.',
      micMissing: 'No encontramos ningún micrófono. Conecta uno y vuelve a intentarlo.',
      micBusy: 'Otra app está usando el micrófono (una llamada o una grabadora). Ciérrala y vuelve a intentarlo.',
      sentence_not_heard: 'No escuchamos la frase completa, con las tres palabras del final. Léela otra vez, un poco más cerca del micrófono.',
      too_short: 'Fue demasiado corto. Lee la frase completa; toma unos 10 segundos.',
      consent_expired: 'Esa frase venció. Aquí tienes una nueva.',
      unreadable_recording: 'No pudimos leer esa grabación. Inténtalo de nuevo.',
      too_many_voices: 'Ya tienes 3 voces. Borra una en Cuenta, Voces, para hacer otra.',
      paid_plan_required: 'Tu propia voz está en los planes de pago.',
      voice_unavailable: 'Grabar voces no está disponible en este momento. Inténtalo más tarde.',
      voice_not_found: 'Esa voz fue borrada. Elige otra.',
      own_voice_too_long: 'Tu propia voz narra videos de hasta 3 minutos. Elige una duración más corta u otra voz.',
      generic: 'Algo salió mal. Inténtalo de nuevo.',
    },
    account: {
      nav: 'Voces',
      title: 'Tus voces',
      subtitle: 'Voces hechas con tu propia grabación. Solo tú puedes usarlas.',
      empty: 'Todavía no tienes voces.',
      delete: 'Borrar',
      deleteQuestion: '¿Borrar esta voz? Los videos que ya hiciste conservan su sonido.',
      deleteConfirm: 'Borrarla',
      keep: 'Conservarla',
      recorded: 'Grabada en {language}',
    },
  },
  clipsCard: {
    title: '¿Tienes un video largo?',
    text: 'AI Clipping lo corta en clips cortos con subtítulos.',
    button: 'Sacar clips',
    close: 'Cerrar',
  },
  aiAgentTabs: {
    video: 'Video',
    scenes: 'Escenas',
    label: 'Agente de IA',
    create: 'Crear un video',
    series: 'Series',
    characters: 'Personajes',
  },
  characters: {
    title: 'Personajes',
    subtitle: 'Tu elenco recurrente. Describe un personaje una vez y se verá igual en cada escena, cada video y cada episodio.',
    new: 'Nuevo personaje',
    yours: 'Tu elenco ({n} de {max})',
    yoursUncapped: 'Tu elenco ({n})',
    loadError: 'No pudimos cargar tus personajes. Actualiza la página para intentarlo de nuevo.',
    emptyTitle: 'Crea tu primer personaje',
    emptyText: 'Un héroe para tus historias, un presentador para tu canal, una mascota para tu marca.',
    deleteTitle: '¿Borrar a {name}?',
    deleteText: 'Los videos que ya hiciste conservan sus imágenes. Las series con este personaje siguen sin él.',
    keep: 'Conservar',
    delete: 'Borrar',
    demo: {
      kicker: 'Personajes consistentes',
      title: 'El mismo personaje en cada escena',
      text: 'Las imágenes con IA suelen cambiar la cara de una escena a otra. Un personaje se dibuja una vez como referencia, y cada imagen en la que aparece se dibuja a partir de ella.',
      steps: {
        describe: 'Describe cómo es: edad, cara, pelo, ropa, colores.',
        draw: 'Dibujamos su retrato de referencia. Dibújalo de nuevo hasta que quede bien.',
        use: 'Elígelo para un video o para toda una serie.',
      },
      frames: {
        portrait: 'La referencia',
        scene1: 'Escena 1',
        scene2: 'Escena 4',
      },
    },
    card: {
      edit: 'Editar a {name}',
      delete: 'Borrar a {name}',
      video: 'Usar en un video',
      series: 'Empezar una serie',
    },
    dialog: {
      newTitle: 'Nuevo personaje',
      editTitle: 'Editar a {name}',
      subtitle: 'Describe lo que siempre se mantiene igual en él. Su retrato será la referencia de cada imagen en la que aparezca.',
      name: 'Nombre',
      namePlaceholder: 'Nour',
      look: 'Cómo es',
      lookPlaceholder: 'Una niña de 10 años con el pelo negro rizado recogido, un pañuelo verde, una camiseta amarilla y un overol de mezclilla, ojos cafés valientes',
      lookHint: 'Edad, cara, pelo, complexión, ropa y colores. Cuanto más concreto, más se mantiene igual.',
      style: 'Dibujado en',
      preview: 'Aquí aparece su retrato.',
      drawing: 'Dibujando a {name}… unos 15 segundos',
      drawingShort: 'Dibujando…',
      portraits: 'Todos los dibujos hasta ahora. Toca uno para usarlo.',
      portraitInUse: 'En uso',
      portraitPick: 'Usar el dibujo {n}',
      consistent: 'Este retrato es lo que lo mantiene igual en cada imagen. Dibújalo de nuevo hasta que quede bien.',
      draw: 'Dibujar personaje',
      redraw: 'Dibujar de nuevo',
      redrawChanged: 'Dibujar con los cambios',
      done: 'Listo',
      picture: 'Empieza desde una imagen (opcional)',
      pictureHint: 'Sube un dibujo, tu mascota, una mascota de marca o una foto tuya',
      pictureLooking: 'Mirando tu imagen…',
      pictureOther: 'Escribimos cómo es a partir de tu imagen. Cambia lo que quieras abajo.',
      picturePerson: 'La foto de una persona siempre se dibuja como ilustración, en uno de los estilos dibujados.',
      pictureConsent: 'Soy yo, o tengo su permiso para usar su foto.',
      pictureRemove: 'Quitar la imagen',
      styleIllustratedOnly: 'Está dibujado desde la foto de una persona, así que los estilos fotográficos no están disponibles.',
    },
    ideas: {
      girl: { label: 'Una joven exploradora', name: 'Nour', look: 'Una niña de 10 años con el pelo negro rizado recogido, un pañuelo verde, una camiseta amarilla y un overol de mezclilla, ojos cafés valientes' },
      grandfather: { label: 'Un narrador', name: 'Abuelo Samuel', look: 'Un anciano amable con barba blanca corta, lentes redondos, un suéter de punto marrón sobre una camisa blanca, sonrisa cálida' },
      detective: { label: 'Una detective', name: 'Detective Vale', look: 'Una mujer de unos 40 años con el pelo plateado corto, un abrigo largo gris oscuro, una bufanda roja, ojos grises penetrantes' },
      robot: { label: 'Un robot compañero', name: 'Bolt', look: 'Un pequeño robot redondo de carcasa blanca, un gran ojo azul brillante, antenas naranjas cortas y ruedas pequeñas' },
    },
    picker: {
      label: 'Personajes',
      optional: '(opcional)',
      manage: 'Administrar',
      remove: 'Quitar a {name}',
      add: 'Agregar un personaje',
      create: 'Crear un personaje',
      hint: 'Agrega un personaje recurrente y se verá igual en cada imagen.',
      chosenHint: 'Se ven igual en cada imagen. Nómbralos en tu idea para darles un papel.',
      seriesHint: 'Cada episodio sigue a uno de ellos, por turnos: hasta {max} en una serie. Toca un nombre para cambiarlo.',
      title: 'Elige personajes',
      subtitle: 'Hasta {max}. Cada uno mantiene la misma cara en cada imagen.',
      seriesHintAny: 'Cada episodio sigue a los que nombra su idea, por turnos. Toca un nombre para cambiarlo.',
      subtitleAny: 'Cada uno mantiene la misma cara en cada imagen.',
      new: 'Nuevo personaje',
      done: 'Listo',
    },
    errors: {
      character_incomplete: 'Ponle un nombre y describe cómo es en una o dos frases.',
      too_many_characters: 'Tienes 12 personajes. Borra uno para crear otro.',
      name_taken: 'Ya tienes un personaje con ese nombre.',
      too_many_portraits: 'Esos son los retratos de hoy. Inténtalo mañana.',
      portrait_failed: 'No pudimos dibujar ese retrato. Inténtalo de nuevo o cambia la descripción.',
      character_not_found: 'Uno de los personajes fue borrado. Elige otro.',
      photo_of_a_child: 'No creamos personajes desde fotos de niños. Descríbelo en su lugar, o sube un dibujo.',
      photo_consent_needed: 'Marca la casilla para confirmar que la foto eres tú, o que tienes su permiso.',
      photo_needs_illustrated_style: 'La foto de una persona solo se dibuja en un estilo ilustrado. Elige otro estilo.',
      picture_unreadable: 'No pudimos leer esa imagen. Prueba con un JPG o PNG.',
      picture_too_large: 'Esa imagen es demasiado grande. Prueba con una de menos de 8 MB.',
      too_many_looks: 'Ya son las imágenes de hoy. Vuelve a intentarlo mañana.',
      look_failed: 'No pudimos mirar esa imagen. Inténtalo de nuevo.',
      generic: 'Algo salió mal. Inténtalo de nuevo.',
    },
  },
  // Series del Agente de IA (pages/SeriesPage.jsx): cada episodio espera a su dueño, y su
  // originalidad es una estimación, nunca la decisión de YouTube
  series: {
    title: 'Series',
    subtitle: "Los próximos videos de tu canal: un episodio nuevo sobre tu tema, en el horario que elijas, cada uno con un ángulo nuevo.",
    promise: 'Cada episodio te espera. No se publica nada hasta que lo revises y lo publiques tú.',
    back: 'Agente de IA',
    link: 'Conviértelo en serie',
    linkHint: 'Un episodio nuevo en tu horario, esperando tu revisión',
    how: {
      review: { title: 'Publicas tú, no nosotros', text: 'Cada episodio se prepara y te llega por email. Míralo, cámbialo y publícalo cuando quieras.' },
      angles: { title: 'Un enfoque nuevo cada vez', text: 'Cada episodio toma otra historia, dato o enfoque de tu tema, nunca uno repetido.' },
      check: { title: 'Un control de originalidad', text: 'Cada episodio se compara con los anteriores, y te avisamos antes de que la serie se vuelva repetitiva.' },
    },
    form: {
      title: 'Empezar una serie',
      topic: '¿De qué trata el canal?',
      topicPlaceholder: 'Leyendas y mitos del antiguo Egipto, contados para adultos. Una leyenda por video, fiel a cómo se cuenta de verdad.',
      topicHint: 'Cada episodio toma una historia, un dato o un enfoque distinto sobre esto.',
      topicTooShort: 'Describe el canal en una o dos frases.',
      name: 'Nombre de la serie (opcional)',
      namePlaceholder: 'Leyendas de Egipto',
      format: 'Formato',
      style: 'Estilo visual',
      language: 'Idioma de la narración',
      voice: 'Narrador',
      duration: 'Duración',
      aspect: 'Formato de pantalla',
      cadence: 'Cada cuánto',
      start: 'Primer episodio',
      startNow: 'Ahora',
      startLater: 'A la hora que elija',
      cost: 'Cada episodio usa uno de los videos con IA de tu plan. Si se acaban, la serie se pausa y te avisamos por email.',
      submit: 'Empezar la serie',
      creating: 'Empezando…',
      freeLength: 'Las series son una función Pro: mejora tu plan para hacer esta serie.',
      tooMany: 'Ya tienes 10 series. Detén una para empezar otra.',
      error: 'No pudimos empezar la serie. Revisa los campos e inténtalo de nuevo.',
    },
    cadence: {
      24: 'Cada día',
      48: 'Día por medio',
      56: '3 veces por semana',
      168: 'Cada semana',
    },
    status: {
      active: 'Activa',
      paused: 'En pausa',
    },
    paused: {
      unreviewed: "En pausa: 5 episodios terminados te esperan. Mira uno y la serie sigue.",
      voice: 'En pausa: la voz del narrador fue borrada. Elige otra y reanúdala.',
      user: 'La pausaste tú.',
      out_of_videos: 'En pausa: a tu plan no le quedan videos con IA en este periodo. Reanúdala cuando se renueven, o mejora tu plan.',
      pro: "En pausa: las series son una función de Pro. Tus episodios siguen aquí; hazte Pro para continuar.",
      goPro: "Hazte Pro",
      out_of_minutes: 'En pausa: a tu plan no le quedan minutos. Reanúdala cuando se renueven, o mejora tu plan.',
      longer_than_plan: 'En pausa: tu plan hace videos de 30 segundos. Acorta los episodios, o mejora tu plan.',
      videosBack: 'Tus videos con IA volvieron: te quedan {n}. Reanuda la serie para seguir.',
      account: 'En pausa.',
    },
    settings: {
      cast: 'Personajes',
      noCast: 'Sin personaje fijo',
      changeCast: 'Cambiar los personajes',
      castTitle: 'Los personajes de la serie',
      castHint: 'Cada imagen que los nombra los dibuja igual. Los próximos episodios lo siguen; los ya hechos quedan como están.',
      look: 'Estilo',
      changeLook: 'Cambiar el estilo',
      lookTitle: 'El estilo de la serie',
      lookHint: 'Los próximos episodios empiezan con esto. Los ya hechos quedan como están.',
      noTitleCard: 'Sin portadas',
      schedule: 'Calendario',
      changeSchedule: 'Cambiar el calendario',
      failed: 'No se pudo guardar. Inténtalo de nuevo.',
    },
    page: {
      numbers: {
        made: 'Episodios hechos',
        waiting: 'Esperándote',
        posted: 'Publicados',
        liked: 'Te gustaron',
      },
    },
    ready: {
      title: 'El episodio {n} está listo',
      watch: 'Ver',
      dismiss: 'Cerrar',
    },
    list: {
      steps: {
        script: 'Escribiendo el guion',
        pictures: 'Dibujando las imágenes y grabando la voz',
        together: 'Montándolo todo',
        finishing: 'Terminando',
      },
      title: 'Tus series',
      empty: 'Todavía no tienes series. Empieza una arriba: el primer episodio se prepara en un minuto, o a la hora que elijas.',
      loadError: 'No pudimos cargar tus series. Recarga la página para intentarlo de nuevo.',
      noEpisodes: 'El primer episodio se preparará a la hora que elegiste.',
      next: 'Próximo episodio: {when}',
      nextSoon: 'El próximo episodio se está preparando ahora.',
      episode: 'Ep. {n}',
      pause: 'Pausar',
      resume: 'Reanudar',
      delete: "Eliminar la serie",
      deleteConfirm: 'No se prepararán más episodios. Los que ya se hicieron siguen en tus proyectos.',
      keep: 'Mantenerla',
    },
    episodeState: {
      posted: 'Publicado',
      reviewed: 'Revisado',
      drafting: 'Preparando…',
      ready: 'Listo para revisar',
      failed: 'Falló',
    },
    check: {
      okBadge: 'Se ve original',
      warnBadge: "Muy parecido",
      ok: 'Se ve distinto de tus últimos {n} episodios: su título, su idea y sus primeras palabras.',
      first: 'El primer episodio: todavía no hay con qué compararlo.',
      advice: 'Reescribe sus primeras líneas o dale otro enfoque antes de publicarlo: las aperturas repetidas y las plantillas son lo que YouTube llama contenido no auténtico.',
      disclaimer: 'Una estimación hecha con las palabras de tus episodios, no la decisión de YouTube.',
      reasons: {
        same_title: 'Su título es casi igual al del episodio {episode}.',
        same_idea: 'Su idea se parece a la del episodio {episode}.',
        opening: 'Empieza casi palabra por palabra como el episodio {episode}.',
        openings: '{similar} de tus últimos {n} episodios empiezan casi igual.',
        titles: '{similar} de tus últimos {n} títulos siguen un mismo patrón.',
      },
    },
    look: {
      titleCard: 'Portadas',
      title: 'El estilo de la serie: los nuevos episodios empiezan con estos subtítulos y esta música. Cámbialos en cualquier episodio.',
      captions: 'Subtítulos: {name}',
      customCaptions: 'a medida',
      noCaptions: 'Sin subtítulos',
      music: 'Música: {name}',
      noMusic: 'Sin música',
    },
    alsoIn: {
      label: 'Haz también cada episodio en',
      hint: 'Hasta {max} idiomas más: las mismas imágenes, narradas de nuevo. Cada uno usa un video con IA más de tu plan.',
      summary: 'También en {languages}, un video con IA más cada uno',
      chip: 'También en {languages}',
      versions: "Otros idiomas",
      failed: "No se pudo hacer",
      translating: 'Traduciendo…',
      skipped: 'No se hizo: no quedan videos con IA',
      skippedOther: 'No se pudo hacer',
    },
    inspiration: {
      open: 'Empieza desde un canal que te guste',
      openHint: 'su nicho, tu propio ángulo',
      label: 'Un canal de YouTube que te guste',
      placeholder: 'youtube.com/@canal o @canal',
      suggest: 'Sugerir',
      reading: 'Leyendo el canal…',
      close: 'Cerrar',
      filled: 'Completado a partir de {channel}: su nicho, tu propio ángulo. Cambia lo que quieras.',
      whatWorks: 'Lo que funciona ahí:',
      different: 'Lo tuyo es distinto:',
      firstIdeas: 'Los primeros episodios podrían ser:',
      errors: {
        bad_link: 'Eso no es un enlace de un canal o video de YouTube.',
        not_found: 'YouTube no tiene ningún canal en ese enlace.',
        no_videos: 'Ese canal no tiene videos públicos para leer.',
        unavailable: 'Esto no está disponible ahora.',
        too_many: 'Ya son suficientes canales por hoy. Vuelve a intentarlo mañana.',
        other: 'No se pudo leer ese canal. Inténtalo de nuevo.',
      },
    },
    calendar: {
      title: 'Lo que viene',
      hint: "Los próximos 7 días de tus series y tus recordatorios para publicar.",
      today: 'Hoy',
      tomorrow: 'Mañana',
      newIdea: 'Una idea nueva',
      post: 'Publicar: {title}',
      yourVideo: 'tu video',
      dragHint: "Arrastra un episodio a otro día para cambiar cuándo se hace, o usa su botón Mover. Los episodios que le siguen en esa serie se mueven con él.",
      touchHint: "Toca Mover en un episodio para cambiar el día en que se hace. Los episodios que le siguen en esa serie se mueven con él.",
      move: "Mover",
      moveTo: "Mover a",
      moved: "Movido a {day} ({time}). Los episodios que le siguen en esa serie se mueven con él.",
      moveFailed: "No se pudo mover. Inténtalo de nuevo.",
      grip: "Arrastra a otro día",
    },
    autoExport: {
      label: 'Exporta cada episodio por mí',
      hint: 'Cada episodio llega como un video terminado con el estilo de la serie, listo para descargar y publicar. Igual puedes cambiarlo y exportarlo de nuevo.',
      chip: 'Se exporta solo',
      exporting: 'Exportando…',
      download: 'Descargar',
    },
    create: {
      title: 'Empieza una serie',
      editTitle: 'Editar {name}',
      editSubtitle: "Los cambios valen para los próximos episodios. Los ya hechos se quedan como están.",
      subtitle: "Un video nuevo sobre tu tema, en el horario que elijas.",
      back: 'Tus series',
      notFound: 'Esta serie no es tuya o ya no existe.',
      cancel: 'Cancelar',
      previous: 'Atrás',
      next: 'Siguiente: {step}',
      start: 'Empezar la serie',
      starting: 'Empezando…',
      save: 'Guardar cambios',
      saving: 'Guardando…',
      savedNote: 'Guardado. Los próximos episodios siguen los nuevos ajustes.',
      startedOne: "Tu serie está lista. El episodio 1 se está haciendo y estará listo para ver en unos minutos.",
      startedMany: "Tu serie está lista. Los primeros {n} episodios se están haciendo y estarán listos para ver en unos minutos.",
      startedAt: "Tu serie está lista. Su primer episodio se hace el {when}.",
      startedLater: "Tu serie está lista.",
      steps: {
        idea: 'Idea',
        look: 'Estilo y sonido',
        when: 'Cuándo',
      },
      topic: '¿De qué trata tu serie?',
      topicPlaceholder: 'p. ej. Leyendas de Latinoamérica contadas para adultos, una por episodio',
      starterReplaced: 'Se reemplazó tu propia idea.',
      starterUndo: 'Volver a mi idea',
      topicHint: 'Con una o dos frases basta. Cada episodio toma una historia, un dato o un ángulo nuevo.',
      niches: {
        title: 'O empieza con un nicho que funciona',
        hint: 'Un toque elige el tema, el formato, el estilo, la música y la voz, y escribe los primeros episodios. Después cambia lo que quieras.',
      },
      captions: {
        title: 'Subtítulos',
        hint: 'Cómo se ve la narración en pantalla, igual en todos los episodios.',
        off: 'Sin subtítulos',
        more: "{n} estilos más",
        custom: 'Tu propio estilo',
        customHint: 'El estilo que hiciste en un episodio. Elige otro para reemplazarlo.',
      },
      music: {
        title: 'Música',
        hint: 'Debajo de la narración, de nuestra propia biblioteca, sin problemas para publicar en cualquier sitio.',
        auto: 'Según cada episodio',
        off: 'Sin música',
        listen: 'Escuchar',
        stop: 'Parar',
      },
      hear: {
        play: 'Escucha un episodio',
        stop: 'Parar',
        what: '{voice} · {music}',
        matched: 'música según cada episodio',
        noMusic: 'sin música',
      },
      mock: {
        caption: 'Nadie sabía por qué',
        countdown: 'Los animales más rápidos',
        quiz: '¿Qué planeta es el más caliente?',
        quizA: 'Venus',
        quizB: 'Mercurio',
        pov: 'Despiertas en Roma, año 79',
        chat1: '¿escuchaste eso?',
        chat2: '¿qué cosa?',
        chat3: 'hay alguien en la casa',
      },
      quickStart: {
        button: "Empezar con esto",
        hint: "El primer episodio se hace a su hora. Cambia lo que quieras después.",
        hintNow: "El episodio 1 se hace ahora y el resto según el horario. Cambia lo que quieras después.",
        hintNowMany: "Los primeros {n} episodios se hacen ahora y el resto según el horario. Cambia lo que quieras después.",
      },
      titleCard: {
        title: 'Abrir cada episodio con su título',
        hint: '"{kicker}" sobre el título del episodio en sus primeros segundos, para que todos parezcan el mismo programa. Cámbialo o quítalo en cualquier episodio.',
        episode: 'Ep. {n}',
      },
      seePreview: 'Ver tu serie',
      format: 'Cómo es un episodio',
      formatHints: {
        story: 'Una historia narrada sobre imágenes',
        countdown: 'Cinco cosas, hasta llegar al #1',
        quiz: 'Preguntas para jugar mientras miras',
        chat: 'Una historia contada como chat',
        pov: 'Estás ahí, mientras pasa',
      },
      moreOptions: 'Nombre y notas',
      fewerOptions: 'Ocultar nombre y notas',
      name: 'Nombre de la serie',
      namePlaceholder: 'Le pondremos nombre a partir de tu tema',
      notes: 'Notas que sigue cada episodio',
      notesPlaceholder: 'Tono, público, qué hacer siempre y qué nunca',
      noteIdeas: {
        kids: 'Para niños de 6 a 9 años',
        gentle: 'Nunca violento ni que dé miedo',
        funny: 'Ligero y divertido',
        facts: 'Solo datos reales y comprobables',
      },
      narratorHint: 'Toca play para escuchar cada una en el idioma de tu serie.',
      listen: 'Escuchar a {name}',
      stop: 'Parar',
      ownVoiceLine: 'Tu propia voz, hasta {minutes} min por episodio',
      shapes: {
        '9x16': 'Vertical',
        '16x9': 'Horizontal',
        '1x1': 'Cuadrado',
        '4x5': 'Retrato',
      },
      perMonth: 'unos {n} videos al mes',
      time: 'A qué hora',
      timeHint: 'Cada episodio se prepara a esa hora, en tu reloj, y te espera.',
      times: {
        morning: 'Mañana',
        afternoon: 'Tarde',
        evening: 'Noche temprano',
        night: 'Noche',
      },
      nowTitle: "Episodios para hacer ya",
      nowHint: "Listos para ver en unos minutos, un video con IA cada uno. El resto sigue el horario.",
      nowNone: "Ninguno",
      nowCount: "{n}",
      lengthLocked: 'Los episodios más largos vienen con un plan de pago.',
      fit: {
        unlimited: 'Tu plan no tiene límite de videos con IA.',
        fits: 'Unos {n} videos con IA al mes. Te quedan {left} este periodo: alcanza.',
        short: 'Unos {n} videos con IA al mes, pero te quedan {left} este periodo: se pausa después de {episodes} episodios y te avisamos por email.',
        none: 'No te quedan videos con IA este periodo: la serie espera hasta que se renueven.',
        upgrade: 'Ver planes',
      },
      card: {
        now: 'Ahora',
        today: 'Hoy',
        tomorrow: 'Mañana',
        week: 'Tu primera semana',
        newIdea: 'Una idea nueva',
        moreThisWeek: "+{n} más esta semana, cada uno con una idea nueva",
        promise: 'No se publica nada: cada episodio te espera.',
        fillsIn: 'Esto se completa a medida que eliges. Muestra los primeros episodios para verlos aquí.',
      },
      preview: {
        title: 'Tus primeros episodios',
        hint: 'Escritos a partir de tu idea en unos segundos, antes de hacer nada. Gratis, y puedes cambiar cualquiera.',
        write: 'Muéstrame los primeros episodios',
        writing: 'Escribiendo tus primeros episodios…',
        rewrite: 'Reescribir',
        remove: 'Quitar',
        edit: 'Editar',
        add: 'Añadir otro',
        again: 'Tu idea cambió desde que se escribieron.',
        againButton: 'Escribirlos de nuevo',
        failed: 'No se pudieron escribir ahora. Inténtalo de nuevo.',
        tooMany: 'Ya son suficientes vistas previas por hoy. La serie igual escribe sus episodios a medida que avanza.',
        episode: 'Episodio {n}',
        more: 'Más',
        less: 'Menos',
        save: 'Guardar',
        cancel: 'Cancelar',
        titleLabel: 'Título del episodio',
        ideaLabel: 'De qué trata el episodio',
        needTopic: 'Primero describe tu serie (una o dos frases).',
      },
    },
    review: {
      hint: "Míralo, di qué te pareció, y guárdalo o publícalo.",
      watch: 'Ver el episodio {n}',
      exporting: 'Se está exportando: se reproduce aquí apenas esté listo.',
      notExported: 'Este todavía no está exportado. Ábrelo para verlo, cambiarlo y exportarlo.',
      feel: '¿Qué te pareció?',
      feelHint: 'Las próximas ideas se inclinan hacia los episodios que te gustan.',
      post: 'Publicarlo',
      openEditor: 'Abrir en el editor',
      redo: 'Hacer este episodio de nuevo',
      redoTitle: '¿Hacer el episodio {n} de nuevo?',
      redoText: 'Una versión nueva ocupa su lugar, con el mismo número. Este video y su archivo se reemplazan. Usa uno de los videos de tu plan.',
      redoKeep: 'Conservar este',
      redoStarted: 'El episodio {n} se está haciendo de nuevo. Aparece aquí cuando esté listo.',
      redoFailed: 'No se pudo hacer de nuevo. Inténtalo en un momento.',
      redoLimit: 'A tu plan no le quedan videos este mes.',
      upNext: 'Lo siguiente:',
      makeNext: 'Hacerlo ya',
      madeNext: 'Se está haciendo. Aparece en la tarjeta de la serie, y el correo avisa cuando esté listo.',
      madeNextFailed: 'No se pudo empezar. Inténtalo desde la tarjeta de la serie.',
      previous: 'Anterior',
      next: 'Siguiente',
      of: '{i} de {total}',
    },
    note: {
      setsLook: 'Los subtítulos y la música que elijas aquí serán el estilo de la serie: los próximos episodios empiezan con ellos.',
      wearsLook: 'Empieza con el estilo de la serie. Cambia aquí los subtítulos o la música y los próximos episodios lo siguen.',
      episode: 'Episodio {n} de {name}',
      seeSeries: 'Ver la serie',
    },
    makeItOne: 'Hazlo una serie: un video nuevo como este en un horario',
    hero: {
      new: 'Nueva serie',
      start: 'Empieza tu primera serie',
    },
    creator: {
      heroHint: 'Esta serie gira en torno a un héroe. Créalo aquí y se verá igual en cada episodio.',
      steps: 'Pasos',
      untitled: 'Tu serie',
      summaryLabel: 'Resumen',
    },
    card: {
      posted: '{n} publicados',
      cost: 'Cada episodio usa 1 de tus {n} videos de IA restantes',
      waiting: '{n} por revisar',
      makeOne: 'Hacer un episodio ahora',
      review: "Revisar episodios",
      making: 'Escribiendo la idea…',
      more: 'Más',
      makeThree: 'Hacer 3 episodios ahora',
      edit: 'Editar serie',
    },
    made: {
      started: "Haciendo {n} ahora. Cada uno estará listo para ver en unos minutos.",
      stopped: {
        out_of_videos: 'A tu plan no le quedan videos de IA en este periodo.',
        out_of_minutes: 'A tu plan no le quedan minutos en este periodo.',
        longer_than_plan: 'Tu plan hace videos de 30 segundos: acorta los episodios o mejora tu plan.',
        already_making: 'Ya se están empezando episodios. Espera un momento.',
        other: 'No pudimos empezar un episodio. Inténtalo de nuevo.',
      },
      upgrade: 'Ver planes',
    },
    starters: {
      title: 'Empieza con una idea',
      more: 'Ideas para tu próxima serie',
      hint: 'Un toque la completa. Cambia lo que quieras.',
      withCast: 'Con un héroe',
      legends: { title: 'Leyendas de Latinoamérica', topic: 'Leyendas de terror de Latinoamérica contadas para adultos: La Llorona, El Silbón, La Sayona, El Cadejo y muchas más. Una leyenda por episodio, fiel a cómo se cuenta en su país.' },
      hero: { title: 'Aventuras para dormir', topic: 'Aventuras tranquilas para dormir, para niños de 4 a 8 años, con el mismo pequeño héroe. En cada episodio un lugar nuevo y una pequeña lección sobre bondad o valentía.' },
      top5: { title: 'Top 5 datos', topic: 'Cuentas regresivas de 5 datos sorprendentes y verdaderos sobre ciencia y naturaleza. Un tema por episodio, hasta llegar al más sorprendente.' },
      pov: { title: 'POV histórico', topic: 'Estás ahí: un día de la historia visto con los ojos de una persona común, en segunda persona. Fiel a la época, una época por episodio.' },
      quiz: { title: 'Hora del quiz', topic: 'Quizzes para jugar mientras miras: preguntas de cultura general cada vez más difíciles, con la respuesta tras una breve pausa.' },
      chat: { title: 'Historias por chat', topic: 'Historias cortas contadas en una conversación de chat entre dos amigos, con un giro al final. Situaciones cotidianas, nunca personas reales.' },
      scary: { title: 'Historias de miedo', topic: 'Historias cortas de miedo para contar de noche: casas embrujadas, vecinos extraños, cosas vistas en caminos vacíos. Historias originales, una por episodio, con un giro al final.' },
      facts: { title: '¿Sabías que…?', topic: 'Un dato sorprendente y verdadero por episodio sobre historia, naturaleza o cosas de todos los días, explicado para que no se olvide. Solo datos reales y comprobables.' },
      fables: { title: 'Pequeñas lecciones', topic: 'Fábulas cortas para niños de 4 a 8 años: un animal aprende algo sobre compartir, la paciencia o la honestidad. Tiernas y divertidas, con una lección clara al final.' },
      stoic: { title: 'Sabiduría estoica', topic: 'Una idea de los estoicos (Marco Aurelio, Séneca, Epicteto) por episodio, contada a través de un momento de su vida y lo que significa para un día como hoy.' },
      love: { title: 'Historias de amor', topic: 'Historias de amor cortas y tiernas: primeros encuentros, amores a distancia, segundas oportunidades. Personas comunes, nunca reales, cada una con un momento que se queda contigo.' },
      whatif: { title: '¿Qué pasaría si…?', topic: '¿Qué pasaría si desapareciera la Luna, si dejáramos de dormir o si se apagara internet un año? Una pregunta por episodio, respondida con ciencia real, paso a paso.' },
    },
    ideaFirst: {
      title: 'Episodio {n}: la idea',
      remakeTitle: 'Episodio {n} de nuevo: su idea',
      newIdea: 'Escribir una idea nueva',
      hint: 'Con esto se hará el episodio. Cambia lo que quieras y luego hazlo. Usa uno de los videos de tu plan.',
      writing: 'Escribiendo la idea…',
      draftFailed: 'No se pudo escribir la idea. Cierra esto e inténtalo de nuevo.',
      make: 'Hacer el episodio {n}',
      remake: 'Hacer el episodio {n} de nuevo',
      failed: 'No se pudo hacer. Inténtalo en un momento.',
    },
    upNext: {
      none: "La próxima idea se escribe cuando le toca al episodio. Agrega la tuya para elegirla.",
      noneWhen: "Próximo episodio {when}: su idea se escribe entonces.",
      all: 'Todas las ideas ({n})',
      title: 'Lo que viene',
      hint: 'Las próximas ideas, antes de hacer nada. Cámbialas, reemplázalas o agrega las tuyas.',
      error: 'No pudimos cargar las próximas ideas. Actualiza para intentarlo de nuevo.',
      writing: 'Escribiendo las próximas ideas…',
      yours: 'Tu idea',
      first: 'La próxima',
      untitled: 'Idea sin título',
      make: 'Hacer ahora',
      edit: 'Editar esta idea',
      swap: 'Cambiar por otra idea',
      earlier: 'Mover antes',
      remove: 'Quitar esta idea',
      add: 'Agregar tu propia idea',
      save: 'Guardar',
      cancel: 'Cancelar',
      titleLabel: 'Título',
      titlePlaceholder: 'Un título provisional',
      ideaLabel: 'La idea',
      ideaPlaceholder: 'De qué trata este episodio y su enfoque',
    },
    continuity: {
      label: 'Episodios',
      standalone: 'Cada uno por su cuenta',
      standaloneHint: 'Una historia, dato o enfoque nuevo cada vez.',
      continuing: 'Una historia que continúa',
      continuingHint: 'Cada episodio sigue donde terminó el anterior.',
    },
    notes: {
      label: 'Notas de la serie (opcional)',
      hint: 'Cada episodio las sigue: tono, público, qué hacer siempre y qué nunca.',
      placeholder: 'Para niños de 6 a 9 años. Cálido y divertido, nunca de miedo. Termina siempre con un acto amable.',
    },
    feedback: {
      up: 'Más como este',
      down: 'Menos como este',
    },
    nudgeTitle: '¿Estás haciendo una serie?',
    nudgeBody: 'Parece una parte de varias. Una serie escribe y hace los siguientes episodios por ti, con el ritmo que elijas, con este estilo y esta voz; tú revisas cada uno antes de publicarlo.',
  },
  fairBilling: {
    eyebrow: 'Cobro justo',
    title: 'Pagas por lo que recibes. Nada más.',
    failTitle: 'Los fallos corren por nuestra cuenta',
    failBody: 'Un video, clip o render que falla no cuesta nada, y rehacer una imagen o una voz dentro de un video nunca cuesta otro video.',
    rollTitle: 'Lo que no usas pasa al mes siguiente',
    rollBody: 'Los minutos y videos de IA que no usas este mes se suman al siguiente, hasta el equivalente a un mes.',
    keepTitle: 'Tus proyectos siguen siendo tuyos',
    keepBody: 'Si cancelas o bajas de plan, tus proyectos y exportaciones siguen en tu cuenta al menos 90 días.',
    note: 'El traspaso es en Pro. Los planes anuales reciben sus minutos y videos cada mes.',
  },
  pricing: {
    badge: 'Más de 10.000 creadores',
    title: 'Precios simples y transparentes',
    subtitle: 'Elige el plan que te sirva. Empieza gratis y mejora cuando quieras.',
    monthly: 'Mensual',
    annual: 'Anual',
    cancelAnytime: 'Cancela cuando quieras',
    localApprox: '≈ {amount} EGP',
    billedInDollars: 'Se cobra en dólares. Tu banco lo convierte a libras egipcias y puede cobrar una pequeña comisión.',
    securePayments: 'Pagos seguros con Stripe',
    noCard: 'El plan gratuito no pide tarjeta',
    grandfatheredTitle: 'Tienes un plan anterior',
    grandfatheredBody: 'Este plan ya no está disponible para nuevos clientes. Puedes conservar tu precio y tus límites o cambiarte al nuevo plan Pro.',
    manage: 'Administrar mi suscripción',
    currentPlan: 'Tu plan actual',
    currentPlanButton: 'Plan actual',
    freeName: 'Gratis',
    freeDescription: "Una hora de clips con IA al mes, con subtítulos y cambio de formato, gratis y sin tarjeta. Los videos con IA vienen con Pro o con un paquete.",
    forever: '/para siempre',
    freeHours: '{n} hora de procesamiento de video al mes',
    clippingTools: 'Clips con IA, subtítulos automáticos, reencuadre',
    repromptOne: '{n} nueva búsqueda de clips por video',
    editorRendering: 'Exportación desde el editor',
    freeAgent: "Videos con IA: {n} videos Pro por {price}, pago único",
    proSeason: '+{n} videos con IA extra este octubre',
    promoTitle: 'Oferta de octubre: {n} videos con IA extra con Pro',
    promoText: 'Suscríbete este mes y te sumamos {n} videos con IA al instante, además de los de tu plan. No caducan.',
    promoRibbon: 'Oferta de octubre · +{n} videos con IA',
    imageRegens: '{n} imágenes regeneradas por video',
    noImageEdits: 'Sin edición de imágenes',
    noAnimations: 'Sin animar imágenes',
    noVoiceRegens: 'Sin regenerar la voz',
    proOnly: 'Solo Pro',
    noWatermarks: 'Exportaciones sin marca de agua',
    editorAccess: 'Acceso al editor de video',
    prioritySupport: 'Soporte prioritario por email',
    freeCta: 'Empieza gratis',
    proName: 'Pro',
    packageSummary: '{hours} h + {videos} videos',
    scale: 'Crece a tu ritmo',
    proHintSubscriber: 'Mueve el control para sumar horas y videos de IA, o para reducirlos.',
    proHint: "Elige cuánto necesitas. Cada paquete suma horas, videos con IA y más intentos; cámbialo cuando quieras.",
    hoursUnit: 'horas',
    hoursSuffix: 'de procesamiento de video al mes',
    repromptMany: '{n} nuevas búsquedas de clips',
    perVideo: 'por video',
    agentVideosUnit: 'videos del Agente de IA',
    perMonth: 'al mes',
    imageRegensBold: '{n} imágenes regeneradas',
    imageEditsBold: '{n} ediciones de imagen',
    animationsBold: '{n} animaciones de imagen a video',
    voiceRegensBold: '{n} regeneraciones de voz',
    deltaUp: '+{hours} h de procesamiento • +{videos} videos de IA',
    deltaDown: '-{hours} h de procesamiento • -{videos} videos de IA',
    openingPortal: 'Abriendo el portal...',
    upgradePlan: 'Mejorar plan',
    downgradePlan: 'Reducir plan',
    processing: 'Procesando...',
    proCta: "Empezar con Pro",
    proCtaMany: "Empezar con Pro: {videos} videos con IA, {amount} hoy",
    proCtaYear: "Empezar con Pro: {amount} hoy, pago anual",
    proFootnote: 'Cancela cuando quieras. Sube o baja de plan a tu ritmo.',
    authTitle: 'Crea tu cuenta',
    authBody: 'Regístrate para suscribirte a un plan.',
    checkoutError: 'Error en el pago',
    checkoutErrorBody: 'No pudimos iniciar el pago. Inténtalo de nuevo.',
    portalError: 'Error en el portal',
    portalErrorBody: 'No pudimos abrir la administración de tu suscripción. Inténtalo de nuevo.',
    slider: {
      perYear: 'año',
      perMonth: 'mes',
      perMonthEq: "{price} al mes, pagando al año",
      saveYear: "Ahorras {amount} al año",
      processing: '{n} h de procesamiento',
      aiVideos: '{n} videos de IA',
    },
    picker: {
      howMany: '¿Cuántos videos con IA al mes?',
      unit: 'videos',
      preset: '{n} videos al mes',
      fewer: 'Menos videos',
      more: 'Más videos',
      firstMonth: 'el primer mes',
      then: 'luego {price} al mes',
    },
    annualSave: "Ahorra {n}%",
    rollOver: "Lo que no usas pasa al mes siguiente",
    howMuch: "¿Cuánto necesitas?",
    moreThan: "¿Necesitas más de {hours} horas al mes?",
    moreThanLink: "Escríbenos",
    compare: {
      title: "Compara los planes",
      subtitle: "Lo que recibes en Gratis y en Pro",
      features: "Qué recibes",
      free: "Gratis",
      pro: "Pro",
      freePrice: "{price} para siempre",
      proPrice: "desde {price} al mes",
      perVideo: "{n} por video",
      perVideoRange: "{a}–{b} por video",
      hours: "{n} h",
      hoursRange: "{a}–{b} h",
      range: "{a}–{b}",
      videosOnce: "Paquete: {n} por {price}",
      rows: {
        hours: "Procesamiento de video al mes",
        hoursHint: "Clips con IA, Subtítulos automáticos, Reencuadre, exportaciones del editor",
        videos: "Videos con IA al mes",
        reprompts: "Nuevas búsquedas de clips",
        redraws: "Imágenes rehechas",
        edits: "Ediciones de imagen",
        animations: "Imágenes animadas",
        voice: "Voces rehechas",
        watermark: "Marca de agua",
        support: "Soporte",
      },
      watermarkFree: "Marca pequeña de Clip-Short",
      supportFree: "Por email",
      supportPro: "Email prioritario",
      yes: "Incluido",
      no: "No incluido",
      bothTitle: "En los dos planes",
      both: "Clips con IA, Subtítulos automáticos, Reencuadre, el editor completo, Series y Personajes, exportaciones en 1080p, descargas y almacenamiento en la nube.",
      bundleNote: "Pro va de un paquete a diez. Cada paquete suma {hours} horas, {videos} videos con IA y su parte de intentos.",
    },
    // Every way to pay in one dated table (components/PricingPage/AtAGlance.jsx)
    glance: {
      eyebrow: "De un vistazo",
      title: "Todas las formas de pagar, en una tabla",
      plan: "Plan",
      includes: "Qué incluye",
      free: "Gratis",
      freePrice: "{price} al mes",
      freeBody: "{minutes} minutos al mes de AI Clipping, subtítulos automáticos y cambio de formato, con una pequeña marca de agua, y el editor completo. Para registrarte no necesitas tarjeta. Sin videos del Agente de IA.",
      pack: "Paquete de {n} videos Pro",
      once: "{price}, pago único",
      packBody: "{n} videos del Agente de IA hechos como en Pro, sin marca de agua. Sin suscripción.",
      clipPack: "Pack de clips",
      clipPackBody: "{minutes} minutos de AI Clipping, todos los clips de esos videos exportados sin marca de agua y {remixes} remixes. Sin suscripción.",
      pro: "Pro, mensual",
      proPrice: "{price} al mes por paquete",
      proBody: "Cada paquete da {hours} horas de procesamiento de video y {videos} videos del Agente de IA al mes, sin marca de agua. Toma de 1 a {max} paquetes y cancela cuando quieras.",
      yearly: "Pro, anual",
      yearlyPrice: "{price} al año por paquete",
      yearlyBody: "{perMonth} al mes. Las {hours} horas y los {videos} videos con IA de cada paquete llegan cada mes del año.",
      fair: "Cobro justo",
      fairBody: "Un video, clip o render que falla no cuesta nada. En Pro, los minutos y videos con IA que no usas se suman al periodo siguiente, hasta el equivalente a un periodo. Si cancelas o bajas de plan, tus proyectos siguen en tu cuenta al menos 90 días.",
    },
    faq: {
      title: "Preguntas sobre los precios",
      subtitle: "Cobro, qué cuenta y qué puedes hacer con los videos.",
      more: "¿Te queda una duda?",
      contact: "Escríbenos a support@clip-short.com",
      items: [
        {
          q: "¿Cómo funciona el precio de Pro?",
          a: "Pro se vende en paquetes. Un paquete son {hours} horas de procesamiento de video y {videos} videos con IA al mes, por {monthly} al mes o {yearly} al año ({yearlyPerMonth} al mes, {saving} menos que pagando mes a mes). Mueve el control para tomar hasta diez; el precio y todo lo que recibes crecen juntos, y lo cambias cuando quieras desde tu cuenta.",
        },
        {
          q: "¿Qué cuenta como tiempo de procesamiento?",
          a: "La duración del video que le das a una herramienta. Un video de 60 minutos cuesta 60 minutos, saques 5 clips o 20: Clips con IA, Subtítulos automáticos y Reencuadre cuentan el video original, y el editor cuenta el video final. Un trabajo que falla no cuesta nada.",
        },
        {
          q: "¿Qué es un video con IA?",
          a: "Un video terminado a partir de una idea que escribes: el guion, imágenes en el estilo que elijas, un narrador, subtítulos y música de nuestra propia biblioteca. Puedes rehacer o editar cualquier imagen, animarla, rehacer la voz y publicar el resultado tal cual. Una serie hace uno según un horario, y cada episodio cuenta como un video con IA.",
        },
        {
          q: "¿Los minutos y videos que no uso pasan al mes siguiente?",
          a: "En Pro, sí. Lo que no uses en un mes pasa al siguiente, hasta el equivalente a un mes. Los planes anuales reciben sus minutos y videos cada mes y los traspasan igual.",
        },
        {
          q: "¿Los videos llevan marca de agua?",
          a: "Las exportaciones gratis llevan una marca pequeña de Clip-Short. Las de Pro salen limpias, y son tuyas: publícalas y úsalas para clientes; si un video se monetiza lo decide cada plataforma.",
        },
        {
          q: "¿Puedo cambiar o cancelar mi plan?",
          a: "Cuando quieras. Agregar paquetes aplica al momento y pagas la diferencia por lo que queda del periodo; quitar paquetes aplica en la próxima renovación; al cancelar, conservas Pro hasta el final de lo que pagaste. Tus proyectos se quedan en tu cuenta de todas formas.",
        },
        {
          q: "¿Y si Pro no es para mí?",
          a: "Escríbenos a support@clip-short.com dentro de los 14 días de tu primer pago y te devolvemos todo, sin preguntas.",
        },
        {
          q: "¿Cómo pago y en qué moneda?",
          a: "Con tarjeta, en el checkout de Stripe; tu número de tarjeta nunca llega a nosotros. En Brasil, el paquete de videos Pro también se paga con Pix, y el checkout muestra los otros métodos que Stripe acepta en tu país. OXXO no está disponible por ahora. Se te cobra en tu moneda cuando Stripe puede hacerlo (euros en Europa, pesos en México, reales en Brasil, etc.) y en dólares en el resto, que tu banco convierte.",
        },
      ],
    },
  },

  suggest: {
    text: 'Este sitio también está en español.',
    link: 'Ver en español',
    close: 'Cerrar',
  },

  season: {
    label: 'Halloween y Día de Muertos',
    message: 'Halloween y Día de Muertos: crea tu video de temporada en minutos.',
    cta: 'Ver ideas',
    paidOffer: 'Oferta de octubre: suscríbete este mes y te sumamos {videos} videos con IA al instante, además de los de tu plan.',
    paidOfferShort: 'Oct: +{videos} videos con Pro',
    paidCta: 'Ver Pro',
    close: 'Cerrar',
  },

  // Sharing a video earns a video, for both people (growth/referral.js)
  videoFeedback: {
    title: '¿Qué tal quedó este video?',
    body: 'Dinos qué te pareció y por qué. Leemos cada respuesta y la usamos para mejorar los próximos videos.',
    good: 'Bien',
    bad: 'Mal',
    thanks: '¡Gracias! Leemos cada respuesta.',
    askGood: '¿Qué fue lo que más te gustó?',
    askBad: '¿Qué salió mal? Cuéntanos para arreglarlo.',
    send: 'Enviar',
    change: 'Cambiar',
    later: 'Ahora no',
    failed: 'No se envió. Inténtalo de nuevo.',
  },
  referral: {
    kicker: "Un video Pro para ti",
    offer: "Comparte este video. Cuando un amigo que traigas compre un paquete o Pro, recibes un video Pro.",
    action: 'Compartir y ganar un video',
    progress: '{joined} amigos se unieron · {earned} de {cap} videos ganados este mes',
    wallAction: "Comparte un video y gana uno Pro",
    exportFirst: "Primero exporta tu video. Después compártelo: cuando un amigo que traigas compre un paquete o Pro, recibes un video Pro.",
  },
  share: {
    button: 'Compartir',
    title: 'Comparte tu video',
    body: 'Cualquiera con el enlace podrá verlo y crear uno igual. Puedes dejar de compartirlo cuando quieras.',
    whatsapp: 'Compartir por WhatsApp',
    facebook: 'Compartir en Facebook',
    copy: 'Copiar enlace',
    copied: 'Enlace copiado',
    stop: 'Dejar de compartir',
    stopped: 'Ya no se comparte: el enlace dejó de funcionar.',
    error: 'No pudimos cambiar cómo se comparte. Inténtalo de nuevo.',
    message: "Mira el video que hice con IA. Haz el tuyo aquí 👉",
    linkTitle: 'Enlace público',
    dialogTitle: 'Compartir este video',
  },
  sharedVideo: {
    clipMadeWith: "Recortado con Clip-Short",
    clipOwn: "Recorta tu propio video",
    clipPitch: "Pega un enlace de YouTube y obtén sus mejores momentos como clips verticales, encuadrados y con subtítulos, en minutos.",
    clipMessage: "Mira este clip 👉",
    bothGet: "Escribe tu propia idea y recibe un video como este: narrado, ilustrado y con subtítulos.",
    madeWith: 'Hecho con Clip-Short',
    idea: 'La idea:',
    makeOne: 'Crear uno igual',
    createFree: "Crea tu video",
    pitch: 'Este video salió de una sola idea. Escribe la tuya y el Agente de IA hace el guion, las imágenes, la narración y los subtítulos.',
    copied: 'Enlace copiado',
    notFoundTitle: 'Este video no está disponible',
    notFoundText: 'Puede que quien lo creó haya dejado de compartirlo. Tú puedes crear el tuyo en minutos.',
    loading: 'Cargando...',
    whatsapp: 'WhatsApp',
    message: 'Mira este video hecho con IA 👉',
  },

  auth: {
    checkStalled: { title: 'El registro se quedó en una verificación de seguridad', body: 'La verificación que frena a los bots no cargó, así que Continuar no puede seguir. Usa Continuar con Google, arriba, o recarga la página. Una VPN o un bloqueador de anuncios pueden impedirla.', google: 'Continuar con Google', reload: 'Recargar la página' },
    loginTitle: 'Inicia sesión en Clip‑Short',
    loginSubtitle: 'Accede a tus proyectos y sigue creando.',
    noAccount: '¿No tienes cuenta?',
    signUp: 'Regístrate gratis',
    signupTitle: 'Crea tu cuenta de Clip‑Short',
    unavailableTitle: 'Clip‑Short no está disponible en tu país',
    unavailableBody: 'Por ahora no puedes registrarte ni iniciar sesión desde aquí.',
    signupSubtitle: 'Empieza en unos segundos.',
    haveAccount: '¿Ya tienes cuenta?',
    signIn: 'Inicia sesión',
    loginError: 'Error al iniciar sesión',
    signupError: 'Error al registrarte',
    authFailed: 'No pudimos iniciar tu sesión. Inténtalo de nuevo.',
    serverError: 'Ocurrió un error en el servidor. Inténtalo más tarde.',
    loadingAccount: 'Cargando tu cuenta',
    accountErrorTitle: 'No pudimos cargar tu cuenta',
    accountErrorText: 'Tu sesión está iniciada, pero nuestro servidor no respondió. Suele volver en unos segundos.',
    tryAgain: 'Intentar de nuevo',
    signOut: 'Cerrar sesión',
    slowText: 'El inicio de sesión está tardando más de lo normal. Puede ser una conexión lenta.',
    reload: 'Recargar la página',
    ideaTitle: 'Tu video está a un paso',
    ideaSaved: 'Tu idea está guardada',
    ideaNext: "Crea tu cuenta y tu idea te espera en la siguiente página, lista para hacerse.",
    signupValue: "1 hora de clips con IA al mes, con subtítulos y cambio de formato, gratis y sin tarjeta.",
    signupSeoTitle: 'Crea tu cuenta gratis de Clip-Short',
    signupSeoDescription: "Una hora de clips con IA al mes, con subtítulos y cambio de formato, sin tarjeta. Regístrate con Google o con tu correo.",
    loginSeoTitle: 'Inicia sesión en Clip-Short',
    loginSeoDescription: 'Tus proyectos, clips y videos con IA. Entra con Google o con tu correo.',
  },

  showcase: {
    sourceVideo: 'Video original',
    aiAnalysis: 'Análisis con IA',
    analyzeVideo: 'Analizar video',
    clipsReady: 'Clips listos para cada plataforma',
    tagVoice: 'Voz',
    tagSentiment: 'Emoción',
    tagMotion: 'Movimiento',
    feedFollowing: 'Siguiendo',
    feedForYou: 'Para ti',
  },
  // The free video's worst picture redrawn by Pro (components/AIAgent/ProPreview.jsx)
  proPreview: {
    eyebrow: "Pro",
    title: "Tu video, en calidad Pro",
    body: "Dibujamos de nuevo una imagen de tu video con nuestro mejor modelo. Arrastra para comparar.",
    // the default since 2026-10-13: one picture drawn again by rule, no defect named
    titleShowcase: "Con Pro, todas tus imágenes se ven así",
    bodyShowcase: "Dibujamos de nuevo una imagen de tu video con nuestro mejor modelo. Arrastra para comparar. Pro hace todo el video con esta calidad.",
    proShowcase: "Pro: mucha más calidad y muchos menos errores",
    ownVoice: "Narra con tu propia voz o cambia la voz cuando quieras",
    titleGallery: "Dale vida a tus personajes con Pro",
    bodyGallery: "Cada imagen hecha con nuestro mejor modelo, y la que elijas convertida en un clip con movimiento.",
    galleryNote: "Hecho con Pro: un personaje en tres escenas, y luego animado",
    galleryAlt: "Un personaje dibujado y animado con Pro",
    chipGallery: "Mira lo que hace Pro",
    animatedBadge: "Animado",
    whatProGallery: "Lo que te da Pro",
    allPicturesGallery: "Todas las imágenes de tus videos con nuestro mejor modelo",
    free: "Gratis",
    pro: "Pro",
    problemFree: "Gratis: {what}",
    proDrawn: "Pro: dibujada otra vez con nuestro mejor modelo",
    proFixed: "Pro: dibujada bien",
    proBetter: "Pro: más nítida y más real",
    allPictures: "Las {n} imágenes de este video con esta calidad",
    allPicturesNoCount: "Cada imagen de tu video con esta calidad",
    later: "Ahora no",
    compare: "Compara la imagen gratis y la imagen Pro",
    chip: "Mira una imagen de tu video dibujada con Pro",
    altFree: "Tu imagen, dibujada con el plan gratis",
    altPro: "La misma imagen, dibujada con Pro",
    kindText: "Texto sin sentido",
    kindExtra: "Un personaje de más",
    kindWrong: "El personaje equivocado",
    kindMissing: "Falta un personaje",
    kindAnatomy: "Una mano o una cara se ve mal",
    kindQuality: "Borrosa y con poco detalle",
    whatPro: "Lo que Pro hace por este video",
    cleanAndLong: "Sin marca de agua, y videos de hasta 10 minutos",
    firstMonth: "tu primer mes",
    off50: "−50%",
    thenMonthly: "después {price} al mes · cancela cuando quieras",
    aMonth: "al mes",
    cancelAnytime: "Cancela cuando quieras",
  },
  checkoutWaiting: {
    label: 'Un pago que dejaste',
    titlePro: 'Tu mejora a Pro te está esperando',
    titlePack: 'Tus 3 videos con IA te están esperando',
    textPro: '{price} hoy. Sigue donde lo dejaste.',
    textPack: '{price}, sin suscripción. Sigue donde lo dejaste.',
    continue: 'Continuar',
    question: '¿Qué te detuvo?',
    answers: {
      too_expensive: 'Muy caro',
      no_subscription: 'No quiero una suscripción',
      payment_problem: 'Un problema con el pago',
      just_looking: 'Solo estaba mirando',
    },
    thanks: 'Gracias, eso nos ayuda.',
    close: 'Cerrar',
    packAddedTitle: "{n} videos Pro añadidos",
    packAddedText: "Ya están en tu cuenta: hasta 3 minutos cada uno, sin marca de agua. Úsalos cuando quieras.",
  },
  // A new account's first video, sold at Generate (components/upgrade/FirstVideoOffer.jsx)
  firstVideo: {
    title: "Tu video está listo para crearse",
    proBadge: "Mejor precio",
    proName: "Pro",
    perMonth: "al mes",
    proVideos: "{n} videos con IA cada mes",
    proClipping: "{n} horas de clips con IA al mes",
    noWatermark: "Sin marca de agua",
    cancelAnytime: "Cancela cuando quieras",
    proCta: "Hazte Pro y crea mi video",
    packBadge: "Sin suscripción",
    packName: "{n} videos Pro",
    once: "pago único",
    packLength: "Hasta {n} minutos cada uno",
    noSubscription: "No se renueva, no hay nada que cancelar",
    packCta: "Comprar por {price} y crear mi video",
    startsAfter: "Tu video empieza solo en cuanto pagues.",
    yourIdea: "Tu idea",
    showcaseTitle: "Hecho con Pro",
    showcaseNote: "Ejemplos de otras ideas",
    showcaseAnimated: "Animado",
    showcase_workshop: "En el taller",
    showcase_balloon: "En globo",
    showcase_stars: "Bajo las estrellas",
    pickAnother: "Toca otro para verlo",
    sound: "Sonido",
    soundOn: "Con sonido",
    playExample: "Reproducir {name}",
    playWithSound: "Reproducir {name} con sonido",
    muteExample: "Silenciar {name}",
    perVideo: "≈ {price} por video",
    secure: "Pago seguro con Stripe",
    changeIdea: "Cambiar mi idea",
    afterProLeft: "¿Prefieres sin suscripción? {n} videos Pro por {pack}, pago único",
    freeTools: "Ahora no: crea clips gratis a partir de un video",
    starting: "Pago recibido. Tu video está empezando…",
    startingSlow: "Tu pago aún se está confirmando. Inténtalo de nuevo en un minuto.",
  },
  // The Remix offer: a remix asked for with no video left (components/Remix/RemixOffer.jsx)
  remixOffer: {
    title: "Tu remix está a un paso",
    starts: "Elige un plan y tu remix empieza solo. No tienes que elegir nada de nuevo.",
    yours: "Tu remix",
    showcaseNote: "Videos hechos con Pro, sin marca de agua. Toca uno para verlo.",
    showcaseNoteRemix: "Remixes hechos con Remix, de clips de dominio público. Toca uno para verlo.",
    proRemixes: "{n} videos de IA o remixes al mes",
    proCta: "Hazte Pro y crea mi remix",
    back: "Volver a mi remix",
    starting: "Pago recibido. Empezando tu remix…",
    slow: "Tu pago aún está en camino. Tu remix empieza en cuanto llegue.",
    failed: "Tu remix no empezó: {reason}",
  },
  // The tools' watermark offer (components/upgrade/WatermarkOffer.jsx, RemoveWatermarkButton.jsx)
  watermarkOffer: {
    button: "Quitar la marca de agua",
    pro: "PRO",
    title: "Exporta sin marca de agua",
    body: "Con Pro, cada clip, video con subtítulos y video redimensionado que exportas sale limpio. Pásate a Pro y vuelve a exportarlo.",
    markGone: "Nuestra marca desaparece de todo lo que exportas",
    showcaseNote: "Pro también hace videos completos como estos. Toca uno para verlo",
    monthlyBadge: "El más elegido",
    monthlyName: "Pro, mensual",
    clean: "Sin marca de agua en nada de lo que exportas",
    hours: "{n} horas al mes de clips, subtítulos y redimensionado",
    videos: "{n} videos con IA al mes, como estos",
    monthlyCta: "Pásate a Pro y quítala",
    yearlyBadge: "{n} meses gratis",
    yearlyName: "Pro, anual",
    perYear: "al año",
    yearlyMonthly: "≈ {price} al mes, en un solo pago al año",
    yearlyCta: "Pagar el año",
    keep: "Seguir con la marca",
  },
  clipExports: {
    title: "Exporta este clip",
    body: "En el plan gratis, tu clip lleva la marca de agua de Clip-Short. Pro exporta todos los clips sin ella, y Remix convierte un clip en un video nuevo como estos.",
    lockedTitle: "Ya exportaste {n} clips gratis de este video",
    lockedBody: "Pro exporta todos los clips de todos tus videos sin marca de agua, y Remix convierte un clip en un video nuevo como estos.",
    freeName: "Plan gratis",
    freeCta: "Exportar con marca de agua",
    freeNote: "Con la marca de agua de Clip-Short",
    left: "Exportaciones gratis que te quedan en este video: {left} de {limit}",
    every: "Todos los clips de todos tus videos, sin marca de agua",
    remix: "Remix: un clip convertido en un video nuevo",
    showcaseNote: "Hechos con Remix, cada uno a partir de un clip. Toca uno para verlo",
    madeWith: "Hecho con Remix",
    lockedHint: "Pro exporta todos los clips",
    cta: "Hazte Pro y exporta todos",
    packName: "Pack de clips",
    packOnce: "Un solo pago, nunca caduca",
    packMinutes: "{n} minutos de AI Clipping",
    packClean: "Todos los clips de esos videos, sin marca de agua",
    packRemixes: "{n} remixes",
    packCta: "Comprar el pack de clips",
    unlockTitle: "Desbloquea este video con tu pack de clips",
    unlockNote: "Usa {n} de los {m} minutos de tu pack. Después, todos los clips se exportan sin marca de agua.",
    unlockCta: "Desbloquear este video",
    unlockShort: "A tu pack de clips no le quedan los minutos de este video",
    again: "Exportar de nuevo sin marca de agua",
    unlocked: "Tu pack de clips está listo. Todos los clips de este video se exportan sin marca de agua.",
    packLeft: "Pack de clips: {m} min · {r} remixes",
    notNow: "Ahora no",
  },
  upgrade: {
    subscriberBody: 'Estás en Pro y ya usaste los videos de este mes. Añade un paquete a tu plan y sigue hoy mismo.',
    subscriberMinutesBody: 'Estás en Pro y te quedaste sin minutos. Añade un paquete a tu plan y sigue hoy mismo.',
    bundleName: 'Un paquete más: {price} al mes',
    addToPlan: 'Añadir a mi plan',
    videosTitle: 'Ya usaste tus videos con IA de este mes',
    freeVideosTitle: "No te quedan videos con IA",
    minutesTitle: 'Te quedaste sin minutos de procesamiento',
    body: 'Pásate a Pro y sigue creando hoy mismo.',
    bodyRenews: 'Tu plan gratis se renueva el {date}. Pásate a Pro y sigue hoy mismo.',
    minutesBody: 'Este video necesita {needed} minutos y te quedan {left}. Pásate a Pro y sigue hoy mismo.',
    planName: 'Pro: {price} al mes',
    planVideos: '{n} videos con IA al mes',
    planHours: '{n} horas de procesamiento de video al mes',
    cta: 'Pásate a Pro por {price} al mes',
    pack: "¿Solo necesitas unos pocos? {n} videos Pro por {price}: hasta 3 minutos, sin marca de agua y sin suscripción",
    ctaLoading: 'Abriendo el pago…',
    secondary: 'Ver todos los planes',
    coupon: 'La mitad de precio el primer mes',
    planNameIntro: 'Pro: {first} el primer mes, luego {price} al mes',
    ctaIntro: 'Pásate a Pro por {first} el primer mes',
    thenPrice: 'La mitad de precio el primer mes, luego {price} al mes. Cancela cuando quieras.',
    firstMinutes: 'O crea clips con los primeros {n} minutos, gratis',
    watermarkTitle: 'Exporta tu video sin marca de agua',
    watermarkBody: 'Con Pro, todos tus videos y clips salen limpios. Pásate a Pro y exporta este de nuevo.',
    animateTitle: 'Anima tus imágenes con Pro',
    animateBody: 'Las imágenes fijas se convierten en clips con movimiento. Pro incluye {n} animaciones por video.',
    editTitle: 'Edita imágenes con IA en Pro',
    editBody: 'Describe el cambio y la imagen se dibuja de nuevo. Pro incluye {n} ediciones con IA por video.',
    generateTitle: 'Genera más imágenes con Pro',
    generateBody: 'Pro incluye {n} imágenes nuevas por video.',
    voiceTitle: 'Rehaz una narración con Pro',
    voiceBody: 'Cambia el texto o la voz de cualquier escena. Pro incluye {n} cambios de voz por video.',
    qualityTitle: "Imágenes dibujadas con nuestro mejor modelo",
    qualityBody: "Pro dibuja cada imagen con nuestro mejor modelo y exporta sin marca de agua.",
    longerTitle: 'Haz videos más largos con Pro',
    longerBody: 'Un video del paquete dura hasta 3 minutos. Con Pro duran hasta 10 minutos.',
    sceneTitle: "Las escenas son de Pro",
    sceneBody: "Una escena animada con su propio sonido y voces, hecha con tu idea. Hazte Pro y crea una ahora.",
    sceneFree: "Hazlo como un video narrado",
    withoutCharacters: "Hacer el video sin personajes",
    seriesTitle: "Las series son de Pro",
    seriesBody: "Un episodio nuevo según tu calendario, escrito de antemano y esperando tu revisión. Hazte Pro y empieza una.",
    charactersTitle: "Los personajes recurrentes son de Pro",
    charactersBody: "La misma cara en cada escena y cada video, dibujada una vez a partir de una descripción o una foto. Hazte Pro y crea tu reparto.",
    subscriberFeatureBody: 'Este video ya usó lo que le da tu plan. Cada paquete que añades le da más a cada video.',
    planNoWatermark: 'Sin marca de agua en tus videos',
    planLonger: 'Videos de hasta 10 minutos',
    planAnimate: 'Imágenes animadas y ediciones con IA',
    planSeason: 'Suscríbete en octubre y recibe {n} videos con IA extra',
  },
  // Los clips de un proyecto de Clips con IA: las tarjetas y el remix de uno
  common: {
    close: 'Cerrar',
  },

  connection: {
    lost: 'No podemos conectar con Clip-Short ahora mismo: esta página puede estar desactualizada. Tus videos siguen procesándose.',
    retrying: 'Reintentando…',
  },

  clips: {
    nextSteps: { title: "Haz tu clip imposible de pasar de largo", text: "Remix arma un video de comentario nuevo alrededor del clip: una apertura que engancha, el contexto investigado con una fuente para cada dato, nombres en pantalla, gráficos y una pregunta para cerrar. O dóblalo a otro idioma.", close: 'Cerrar' },
    show: 'Mostrar',
    filters: { all: 'Todos', top: 'Los mejores', exported: 'Exportados' },
    sortLabel: 'Ordenar los clips',
    sortBest: 'Mejores primero',
    sortTimeline: 'Orden del video',
    emptyExported: 'Todavía no exportaste nada. Los clips exportados aparecen aquí, listos para descargar.',
    empty: 'Aún no hay clips aquí.',
    clipScore: 'Puntuación del clip',
    clipScoreTitle: 'Puntuación del clip {score} de 100',
    score: { excellent: 'Excelente', strong: 'Muy bueno', good: 'Bueno', fair: 'Aceptable' },
    place: '{length} · {from}–{to} del video original',
    why: 'Por qué este clip',
    captionsBurned: 'Subtítulos incrustados',
    captionsNone: 'Sin subtítulos',
    captionsNamed: "Subtítulos: {name}",
    playLabel: 'Reproducir el clip: {title}',
    openLabel: 'Abrir el clip: {title}',
    editLabel: 'Editar el clip: {title}',
    download: 'Descargar',
    open: 'Abrir el clip',
    edit: 'Editar el clip',
    export: 'Exportar el clip',
    exporting: 'Exportando…',
    project: {
      clippingTitle: 'Buscando tus clips',
      clippingDone: 'Puedes irte: los clips aparecen aquí cuando estén listos.',
      captionsTitle: 'Transcribiendo tu video',
      captionsDone: 'Puedes irte: la transcripción aparece aquí cuando esté lista.',
      reframeTitle: 'Reencuadrando tu video',
      reframeDone: 'Puedes irte: el video reencuadrado aparece aquí cuando esté listo.',
      stepFetch: 'Descargando el video',
      stepMoments: 'Buscando los mejores momentos',
      stepFraming: 'Encuadrando y subtitulando cada clip',
      stepListening: 'Escuchando cada palabra',
      stepSaving: 'Guardando la transcripción',
      stepTracking: 'Siguiendo al protagonista y reencuadrando cada plano',
      stepUploading: 'Subiendo el resultado',
      wentWrong: 'Algo salió mal. Inténtalo de nuevo.',
      usually: 'Suele tardar unos minutos.',
      lookingFor: 'Buscando:',
      didntFinish: 'No terminó',
      noMomentsTitle: 'La IA no encontró suficientes momentos claros en este video.',
      noMomentsHint: 'Prueba con un encargo más amplio, o pide menos clips.',
      noSoundTitle: 'Este video no tiene sonido.',
      noSoundHint: 'Los subtítulos salen de lo que se dice. Prueba con un video en el que alguien hable.',
      fetchTitle: 'No pudimos descargar este video.',
      fetchHint: 'Puede ser privado, tener restricción de edad o estar borrado. Revisa el enlace, o sube el archivo.',
      downloadSlowTitle: "La descarga no terminó a tiempo.",
      downloadSlowHint: "Un video muy largo (de varias horas, como la grabación de un directo) puede tardar más de lo que permitimos, aunque solo recortes una parte. Sube el archivo, o un video más corto.",
      ytUnavailableTitle: "Este video ya no está en YouTube.",
      ytPrivateTitle: "Este video es privado en YouTube.",
      ytAgeTitle: "YouTube tiene este video detrás de una verificación de edad.",
      ytMembersTitle: "Este video es solo para los miembros del canal.",
      ytRegionTitle: "YouTube no muestra este video desde donde lo descargamos.",
      ytNotYetTitle: "Este video todavía no se ha estrenado en YouTube.",
      ytHint: "Volver a intentarlo no lo cambiará. Elige otro video, o sube el archivo si lo tienes.",
      ytNotYetHint: "Inténtalo cuando se haya emitido, o sube el archivo si lo tienes.",
      aiTitle: 'El servicio de IA no respondió a tiempo.',
      aiHint: 'Tu video no tiene nada malo: inténtalo de nuevo en un momento.',
      genericTitle: 'Algo salió mal al procesar este video.',
      genericHint: 'Inténtalo de nuevo. Si sigue fallando, los detalles de abajo nos ayudan a investigarlo.',
      retryLabel: '¿Qué debe buscar la IA esta vez?',
      askedFor: 'La vez pasada pediste {n}',
      retrying: 'Reintentando…',
      retryChanged: 'Intentar con este encargo',
      retry: 'Intentar de nuevo',
      repromptTitle: 'Buscar clips nuevos',
      repromptBody: 'La IA repasa el video entero con tu encargo en mente. Los clips nuevos se suman a los que ya tienes.',
      repromptPlaceholder: 'P. ej. La parte de los precios, algo polémico, la historia del primer cliente…',
      have: 'Ya tienes {n}',
      cancel: 'Cancelar',
      starting: 'Empezando…',
      findClips: 'Buscar clips',
      backAllClips: 'Volver a todos los clips',
      exportFailed: 'La exportación no empezó',
      reframeFailed: 'No se pudo empezar el reencuadre. Inténtalo de nuevo.',
      deleteThis: 'Borrar este proyecto',
      deleteConfirm: 'Borrar el proyecto',
      deleteBody: '¿Seguro que quieres borrar «{title}»? Se borrarán para siempre todos los datos de este proyecto, incluidos los clips ya extraídos. Esto no se puede deshacer.',
      repromptPasses: 'Te quedan {left} de {limit} búsquedas en este video. Esta gasta una.',
      repromptPassesNone: 'No te quedan búsquedas en este video con tu plan.',
      repromptRefused: 'Las búsquedas de tu plan en este video se agotaron ({used} de {limit}).',
      repromptFailed: 'No se pudo empezar la búsqueda. Inténtalo de nuevo.',
    },
    bar: {
      back: 'Volver a los proyectos',
      finding: 'Buscando clips nuevos…',
      findingN: 'Buscando {n} clips nuevos…',
      noClips: 'Todavía no hay clips',
      preparing: 'Preparando vistas previas · {ready} de {total} listas',
      ready: 'Vistas previas listas',
      source: '{length} de origen',
      clips: '{n} clips',
      clipsOne: '{n} clip',
      more: 'Más acciones',
      deleteProject: 'Borrar el proyecto',
      runsLabel: 'Clips de',
      findNew: 'Buscar clips nuevos…',
      findNewLocked: 'Buscar clips nuevos',
      repromptLimit: 'Las búsquedas de tu plan {plan} en este video se agotaron ({used} de {limit}). Los planes más grandes tienen más.',
      runOriginal: 'Original',
      runAll: 'Todos',
      runPrompt: 'Encargo {n}',
    },
    status: {
      exporting: 'Exportando…',
      waiting: 'En espera para exportar (2 a la vez)',
      captioning: 'Añadiendo subtítulos…',
      exportFailed: 'Falló la exportación',
      captionsFailed: 'Fallaron los subtítulos',
      exportedCaptions: 'Exportado con subtítulos',
      exported: 'Exportado',
      queued: 'En cola para la vista previa',
      preparing: 'Preparando la vista previa…',
      ready: 'Listo',
      outdated: 'Vista previa desactualizada',
      previewFailed: 'Falló la vista previa',
      noPreview: 'Todavía sin vista previa',
    },
    remixes: {
      one: 'Remix de este clip',
      many: '{n} remixes de este clip',
      making: 'Creándolo…',
      ready: 'Listo',
      failed: 'Falló',
    },
    remix: {
      dubSound: "Doblaje en {language}",
      action: 'Remix',
      tooltip: 'Crea un video nuevo alrededor de este clip: un título en pantalla, un gancho narrado, comentarios mientras se reproduce y un cierre',
      title: 'Remix de este clip',
      lead: "Un video nuevo construido alrededor de tu clip, escrito a partir de lo que se dice en él.",
      untitled: 'Clip sin título',
      ownSound: 'se reproduce con su propio sonido',
      format: 'Formato',
      formats: {
        didYouKnow: {
          kicker: "¿Sabías que…?",
          headline: "Casi todos se equivocan en esto",
          label: '¿Sabías que...?',
          description: 'Un gancho sorprendente que el clip responde.',
          example: '«¿Sabías que casi todo el mundo se equivoca en esto?»',
        },
        explainer: {
          kicker: "Explicado",
          headline: "Lo que esto significa de verdad",
          label: 'Explicación',
          description: 'Primero el contexto y luego se detiene para explicar.',
          example: '«Esto es lo que tienes que saber antes de verlo.»',
        },
        hotTake: {
          kicker: "Opinión polémica",
          headline: "Nadie está diciendo esto",
          label: 'Opinión',
          description: 'Reacciona mientras se reproduce y después da su opinión.',
          example: '«Es la respuesta más honesta que he oído en mucho tiempo.»',
        },
        backstory: {
          kicker: "La historia",
          headline: "Cómo empezó todo",
          label: 'La historia detrás',
          description: 'La historia que lleva hasta este momento.',
          example: '«Todo empezó con una pregunta...»',
        },
        custom: {
          kicker: "Tu idea",
          headline: "Tu video, a tu manera",
          label: 'A tu manera',
          description: 'Describe el video que quieres.',
        },
      },
      direction: 'Indicaciones',
      describe: 'Describe tu video',
      directionPlaceholder: 'Opcional: algo en lo que enfocarse, o un tono. P. ej. «que sea divertido», «céntrate en la segunda mitad».',
      describePlaceholder: 'P. ej. Empieza con la pregunta del inicio y luego explica por qué le importa a los estudiantes.',
      commentary: 'Cuánto comenta la IA',
      levels: {
        light: { summary: "Pocos comentarios", label: 'Poco', hint: 'Gancho y cierre, y como mucho un comentario dentro del clip.' },
        balanced: { summary: "Comentarios equilibrados", label: 'Equilibrado', hint: 'Un comentario cada 25 segundos de clip, hasta 3.' },
        lots: { summary: "Muchos comentarios", label: 'Mucho', hint: 'Reacciona seguido: un comentario cada 15 segundos, hasta 6.' },
      },
      language: 'Idioma de la narración',
      voice: 'Voz',
      playVoice: 'Escuchar una muestra de la voz',
      stopVoice: 'Detener la muestra de la voz',
      optional: "(opcional)",
      narration: "Voz e idioma",
      costLeft: "Usa un video de IA (te quedan {n}). Listo en un minuto o dos.",
      costUnlimited: "Listo en un minuto o dos.",
      costPro: "Se hace con Pro o un paquete de videos, sin marca de agua.",
      // The sketch of the remix beside the choices (RemixPreview.jsx)
      preview: {
        label: "Tu remix",
        hook: "Gancho",
        clip: "Clip",
        comment: "Comentario",
        ending: "Cierre",
        note: "Un boceto: la IA escribe el título y cada comentario a partir de lo que se dice en el clip.",
        voiceOver: "Una voz de IA lo abre",
      },
      // Remix v2: angles instead of formats (components/Remix/AnglePicker.jsx)
      v2: {
        lead: "La IA lee tu clip, encuentra la historia detrás y arma un video nuevo a su alrededor: un arranque con el mejor momento, el contexto con tomas del video, gráficos, sus comentarios y un cierre.",
        step: "Elige un enfoque",
        reading: "Leyendo tu clip para proponer enfoques…",
        failed: "Esta vez no hay enfoques. Deja que la IA elija, o escribe el tuyo.",
        aiChoice: "Que la IA elija",
        aiChoiceHint: "Elige la historia más fuerte del clip y de lo que encuentra sobre él.",
        own: "Mi propio enfoque",
        ownPlaceholder: "¿De qué debería tratar el video? P. ej. «La historia detrás de este momento»",
      },
      // Editing a v2 remix on its video page (components/Remix/RemixV2Editor.jsx)
      v2edit: {
        title: "Editar el remix",
        kicker: "Etiqueta",
        line: "Línea {n} del título",
        stars: "Pon entre *asteriscos* las palabras a resaltar: salen en el color de acento.",
        question: "Pregunta final",
        name: "Nombre",
        role: "Rol",
        removeTag: "Quitar esta etiqueta de nombre",
        graphic: "Escena {n}: {kind}",
        removeGraphic: "Quitar este gráfico",
        shots: "Tomas",
        shotsHint: "Cada parte narrada muestra tomas del video original. Elige otra: se guarda al instante.",
        part: "Parte {n}",
        change: "Cambiar",
        useShot: "Usar esta toma",
        cancel: "Cancelar",
        shotsLoading: "Cargando las tomas…",
        shotsFailed: "No se pudieron cargar las tomas.",
        noShots: "Este video no tiene otras tomas cerca del clip.",
        shotFailed: "No se pudo cambiar la toma. Inténtalo de nuevo.",
        kinds: {
          display: "pantalla",
          target: "objetivo",
          gauge: "indicador",
          counter: "contador",
          pin: "ubicación",
          document: "documento",
          stamp: "sello",
        },
        fields: {
          label: "Etiqueta",
          note: "Nota",
          stamp: "Sello",
          value: "Número",
          title: "Lugar",
          sub: "Línea de abajo",
          header: "Encabezado",
          line: "Línea",
          cutNote: "Nota al tachar",
          keptText: "Sello al conservar",
          text: "Texto",
        },
        quote: "Cita, escena {n}",
        failed: "No se pudo guardar. Inténtalo de nuevo.",
        saved: "Guardado",
        save: "Guardar cambios",
      },
      cancel: 'Cancelar',
      submit: "Hacer el remix",
      submitPro: "Remix con Pro",
      starting: 'Empezando…',
      off: 'Remix no está activado en este servidor (REMIX_ENABLED).',
      failed: 'No se pudo empezar el remix. Inténtalo de nuevo en un momento.',
    },
    // El espacio de trabajo del clip: el editor en el que se abre — su
    // transcripción, el escenario, la línea de tiempo, el encuadre, los
    // ajustes y la tira de clips
    workspace: {
      backToPreview: 'Volver a la vista previa',
      // Los tres paneles, y lo que impide editar un clip ya exportado
      transcript: 'Transcripción',
      preview: 'Vista previa',
      settings: 'Ajustes del clip',
      selectClip: 'Elige un clip para ver su vista previa.',
      lockedExported: 'Los clips exportados conservan sus subtítulos. Edita una copia para cambiarlos.',
      lockedExporting: 'Bloqueado mientras se exporta el clip',
      prepareFailed: 'No se pudo preparar la vista previa',
      captionsSaveFailed: 'No se pudieron guardar los subtítulos',
      exportFailed: 'La exportación no empezó',
      // La transcripción de la izquierda
      transcriptText: 'Texto de la transcripción',
      wordText: 'Texto de la palabra',
      saving: 'Guardando…',
      editsSaved: 'Tus cambios están guardados · un punto devuelve una palabra cortada',
      editHint: 'Haz clic en cualquier palabra para corregirla · bórrala para cortarla',
      restoreOriginal: 'Restaurar el original',
      loadingTranscript: 'Cargando la transcripción…',
      transcribing: 'Transcribiendo. La transcripción llega con la vista previa.',
      noTranscript: 'Todavía no hay transcripción. Prepara la vista previa para transcribir este clip.',
      noSpeech: 'En este clip nadie habla.',
      editWord: 'Editar «{word}»',
      playFrom: 'Reproducir desde «{word}»',
      putBack: 'Devolver «{word}»',
      // La barra encima del escenario
      aspectRatio: 'Proporción',
      framing: 'Encuadre',
      automatic: 'Automático',
      editedShotOne: 'Editado ({n} plano)',
      editedShots: 'Editado ({n} planos)',
      adjustFraming: 'Ajustar el encuadre',
      preparePreview: 'Preparar la vista previa',
      refreshPreview: 'Actualizar la vista previa',
      refreshing: 'Actualizando…',
      refresh: 'Actualizar',
      outdatedHint: 'Este clip ahora empieza o termina fuera del rango que se preparó, así que la vista previa está desactualizada. Las exportaciones se renderizan en calidad completa de todos modos.',
      previewQuality: 'Calidad de la vista previa',
      qualityHint: 'Lo que reproduce la vista previa. Las exportaciones siempre se renderizan desde el original a resolución completa.',
      // La etiqueta sobre la imagen: qué se está reproduciendo
      badgeFast: 'Vista previa 360p',
      badgeToHd: 'Una vista previa rápida en 360p. Las exportaciones se renderizan a resolución completa. Cambia a HD',
      badgeToFast: 'Reproduciendo el original. Cambia a la vista previa rápida en 360p',
      badgeStatic: 'Una vista previa rápida en 360p. La exportación se renderiza a resolución completa',
      // La línea de tiempo bajo el escenario
      play: 'Reproducir',
      pause: 'Pausar',
      mute: 'Silenciar',
      unmute: 'Activar el sonido',
      playhead: 'Cabezal de reproducción',
      trimInHandle: 'Recortar la entrada',
      trimOutHandle: 'Recortar la salida',
      framingPin: 'Marca de encuadre',
      // El modo de encuadre
      editedShot: 'plano editado',
      automaticShot: 'plano automático',
      split: 'Dividir',
      splitHint: 'Divide en dos recortes apilados a partir de aquí',
      merge: 'Unir',
      mergeHint: 'Vuelve a un solo recorte a partir de aquí',
      pin: 'Fijar',
      pinHint: 'Fija el encuadre aquí. Añade otra marca para desplazarte entre ambas',
      deletePin: 'Borrar la marca',
      deletePinHint: 'Quita la marca que está en el cabezal. El encuadre a su alrededor se mantiene',
      resetShot: 'Restablecer el plano',
      resetShotHint: 'Encuadre automático para este plano',
      resetAll: 'Restablecer todo',
      resetAllHint: 'Encuadre automático en todos los planos',
      cancel: 'Cancelar',
      done: 'Listo',
      saveDone: 'Guardar y listo',
      framingHint: 'Arrastra el recuadro para reencuadrar este plano. Los demás planos conservan su encuadre automático.',
      // Los ajustes de la derecha
      trim: 'Recortar',
      long: '{length} de duración',
      trimIn: 'Entrada',
      trimOut: 'Salida',
      stepEarlier: '{label} 1 segundo antes',
      stepLater: '{label} 1 segundo después',
      trimLocked: 'Los clips exportados conservan sus tiempos.',
      trimHint: 'Recorta a tu gusto o extiéndelo: lo que pase de la parte preparada recibe su encuadre y subtítulos solo, mientras sigues editando.',
      captions: 'Subtítulos',
      burnCaptions: 'Incrustar los subtítulos',
      captionsExported: 'Los subtítulos son parte del archivo exportado. Cámbialos para renderizar una versión nueva.',
      changeCaptions: 'Cambiar los subtítulos…',
      hintBurned: 'subtítulos incrustados',
      hintCaptions: 'subtítulos {name}',
      hintNoCaptions: 'sin subtítulos',
      openEditor: 'Abrir en el editor completo',
      // La tira de clips de abajo
      clipsTitle: 'Clips',
      drag: 'arrastra',
      scoreTitle: 'Puntuación del clip {score} de 100',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      editHintTouch: 'Toca cualquier palabra para corregirla · bórrala para cortarla',
      tools: 'Herramientas',
      sheetMore: 'Ver más del panel',
      sheetLess: 'Ver menos del panel',
    },
    feed: { label: 'Clips, uno por pantalla', soundOn: 'Activar el sonido', soundOff: 'Silenciar' },
  },

  // Las páginas de cada herramienta: el hero, el compositor, la
  // configuración cuando ya hay un video, y los proyectos de abajo
  toolPage: {
    step1: 'Pega un enlace o suelta un archivo',
    clipping: {
      headline: 'Pega un video. Publica lo mejor.',
      sub: 'La IA encuentra los momentos que enganchan, encuadra en vertical a quien habla y pega los subtítulos. Tú revisas, ajustas y exportas.',
      step: 'Dale unos 3 minutos',
      last: 'Revisa, ajusta y exporta',
      eta: '3 minutos',
      setup: 'Configura tus clips',
      note: 'Unos {eta} · La IA elige la duración de cada clip; después puedes recortarlos.',
      cta: 'Sacar clips',
    },
    captions: {
      headline: 'Subtítulos que la gente sí lee.',
      sub: 'La IA transcribe cada palabra y pega los subtítulos en el estilo que elijas. Pega un enlace o suelta un archivo.',
      step: 'Dale unos 2 minutos',
      last: 'Míralo y descárgalo',
      eta: '2 minutos',
      setup: 'Listo para subtitular',
      setupSub: 'La IA transcribe cada palabra al ritmo de la voz. El estilo de los subtítulos lo eliges en el resultado.',
      note: 'Unos {eta}',
      cta: 'Generar subtítulos',
    },
    reframe: {
      headline: 'Cualquier video, cualquier formato.',
      sub: 'La IA reencuadra cualquier video alrededor de su protagonista: vertical, cuadrado o ancho. Pega un enlace o suelta un archivo.',
      step: 'Dale unos 2 minutos',
      last: 'Míralo y descárgalo',
      eta: '2 minutos',
      setup: 'Configura el reencuadre',
      note: 'Unos {eta} · La IA mantiene al protagonista en cuadro, plano a plano.',
      cta: 'Reencuadrar video',
    },
    segment: {
      title: 'Qué procesar',
      whole: 'Video entero · {length}',
      choose: 'Elegir una parte',
      first: 'Los primeros {time}',
      from: 'Desde',
      to: 'Hasta',
      startLabel: 'Inicio de la parte',
      endLabel: 'Final de la parte',
      frameAt: 'Fotograma en {time}',
      watch: 'Ver desde {time} en YouTube',
      wholeVideo: 'El video entero',
      toProcess: '{length} para procesar',
      uses: 'usa {used} de los {left} minutos que te quedan',
      minClipping: 'Clips con IA necesita al menos 5 minutos para encontrar clips.',
      minCaptions: 'Elige al menos unos segundos.',
      maxReframe: 'El reencuadre procesa hasta 30 minutos por vez.',
      overMinutes: 'Son {length} minutos y a tu plan le quedan {left} este mes.',
      choosePart: ' Elige una parte para procesar solo un trozo.',
      noteReframe: 'El reencuadre procesa hasta 30 minutos por vez, así que elegimos los primeros {time}. Arrastra los controles para elegir otra parte.',
      noteMinutes: 'A tu plan le quedan {n} minutos este mes, así que elegimos los primeros {time}. Arrastra los controles para elegir otra parte, o procesa el video entero con un plan mayor.',
    },
    clipSetup: {
      tooShort: 'Este video dura menos de 5 minutos: es muy corto para sacar clips. Elige uno más largo.',
      tooShortTry: 'Pero este video sirve para:',
      tooShortReframe: 'Hacerlo vertical (9:16)',
      tooShortCaptions: 'Agregar subtítulos',
      howMany: 'Cuántos clips',
      suggest: 'Sugerimos {n} para {length} de video',
      suggested: ' (sugerido)',
      minutes: '{n} min',
      hours: '{h} h {m} min',
      promptLabel: '¿Qué debe buscar la IA?',
      optional: 'opcional',
      promptPlaceholder: 'P. ej. La parte de los precios, sáltate la intro, nada antes del minuto 5',
      ideasLabel: 'Ideas para el encargo',
      ideas: {
        funniest: 'Los momentos más divertidos',
        takeaways: 'Las ideas clave',
        opinions: 'Opiniones fuertes',
      },
      suggestPart: 'Sugerimos {n} para la parte de {length}',
    },
    composer: {
      upload: 'Subir',
      placeholder: 'Pega un enlace de YouTube, Twitch, Drive o X…',
      urlLabel: 'URL del video',
      clearUrl: 'Borrar la URL',
      paste: 'Pegar',
      drop: 'Suelta tu video para subirlo',
      dropHint: 'o arrastra y suelta aquí un archivo de video',
      showcaseTimed: 'Cada palabra, al ritmo de la voz',
      showcaseStyle: 'En el estilo que elijas',
      captionStyle: 'Estilo de los subtítulos',
      worksWith: 'Funciona con',
      clearFile: 'Quitar el archivo elegido',
      reading: 'Leyendo el video…',
      readingSlow: 'Este está tardando unos segundos. Sigue en marcha.',
      yourVideo: 'Tu video',
      ready: 'Listo',
      views: '{n} visitas',
    },
    ready: {
      notUploaded: 'Elegido · aún sin subir',
      notThisOne: '¿No es este?',
      anotherFile: 'Elige otro archivo',
      anotherLink: 'Pega otro enlace',
      uploading: 'Subiendo',
      uploadFile: 'Subir el archivo',
    },
    button: {
      starting: 'Empezando…',
      uploading: 'Subiendo…',
      chooseFile: 'Elige un archivo',
      uploadFirst: 'Sube el archivo primero',
      invalidLink: 'Pega un enlace válido',
    },
    reframeSetup: {
      format: 'Formato de salida',
      padding: 'Cuando un plano no llena el cuadro',
      paddingNote: 'relleno',
      blur: 'Desenfoque',
      black: 'Negro',
      tooLong: 'Este video dura {minutes} minutos. El reencuadre procesa hasta 30 minutos por vez.',
      over30: 'más de 30',
    },
    existing: {
      clips: 'Ya tienes clips de este video{detail}.',
      captions: 'Ya tienes subtítulos de este video{detail}.',
      reframe: 'Ya tienes un reencuadre de este video{detail}.',
      open: 'Ábrelo →',
      clipCount: '{n} clips',
    },
    refusal: {
      firstMinutes: 'Crea clips con los primeros {n} minutos',
      moreMinutes: 'Consigue más minutos',
    },
    projects: {
      title: 'Tus proyectos',
      inProgress: 'En proceso',
      loadError: 'Error al cargar los proyectos',
      emptyTitle: 'Todavía no hay proyectos',
      emptyBody: 'Pega un enlace arriba: tus primeros clips están a unos minutos.',
      emptyCaptionsTitle: 'Todavía no hay subtítulos',
      emptyCaptionsBody: 'Pega un enlace arriba: tu video subtitulado está a un par de minutos.',
      emptyReframeTitle: 'Todavía no hay reencuadres',
      emptyReframeBody: 'Pega un enlace arriba: el reencuadre tarda más o menos lo que dura el video.',
      emptyCta: 'Añadir un video',
      emptyDefault: 'Pega un enlace arriba: tu primer resultado está a unos minutos.',
    },
    limit: {
      title: 'Llegaste al límite del mes',
      body: 'Ya usaste todos los proyectos de este mes. Pásate a Pro para tener proyectos ilimitados.',
      close: 'Cerrar',
      pricing: 'Ver precios',
    },
    remove: {
      title: '¿Borrar el proyecto?',
      body: '¿Seguro que quieres borrar «{title}»? Esto no se puede deshacer.',
      thisProject: 'este proyecto',
      stillCounts: "Borrarlo no te devuelve el video: sigue contando.",
      cancel: 'Cancelar',
      deleting: 'Borrando…',
      confirm: 'Borrar',
    },
    card: {
      processing: 'Procesando…',
      failed: 'Falló',
      deleteLabel: 'Borrar el proyecto',
      clips: '{n} clips',
      scenes: '{n} escenas',
      scene: "Escena",
      series: 'Serie · {name}',
    },
  },

  // A scene clip: one short animated scene with its own sound (components/AIAgent/Scene*.jsx)
  studio: {
    label: "Estudio de IA",
    seeAll: "Ver todos",
    open: "Mostrar lo que hay en {name}",
    close: "Ocultar lo que hay en {name}",
    videoTitle: "Crea un video",
    videoSubtitle: "Un narrador cuenta tu idea sobre imágenes y subtítulos. De 1 a 10 minutos.",
    modes: {
      video: {
        name: "Video",
        what: "Con narrador, de 1 a 10 minutos",
        new: "Nuevo video",
      },
      scenes: {
        name: "Escenas",
        what: "Una toma animada de {n} segundos",
        new: "Nueva escena",
      },
      series: {
        name: "Series",
        what: "Videos nuevos en un horario",
        new: "Nueva serie",
      },
      characters: {
        name: "Personajes",
        what: "Tu elenco de siempre",
        new: "Nuevo personaje",
      },
    },
    empty: {
      video: "Aquí aparecerán tus videos.",
      scenes: "Aquí aparecerán tus escenas.",
      series: "Aquí aparecerán tus series.",
      characters: "Aquí aparecerán tus personajes.",
    },
  },
  sceneGuide: {
    sceneTitle: "Tu idea es un solo momento. Prueba una Escena",
    sceneBody: "Los videos los cuenta un narrador sobre imágenes. Un momento animado se hace en Escenas.",
    storyTitle: "Tu idea es una historia completa",
    storyBody: "El video con narrador la cuenta entera. Una Escena mostraría solo un momento.",
    videoName: "Video con narrador",
    videoFacts: [
      "Un narrador lo cuenta sobre imágenes y subtítulos",
      "De 1 a 10 minutos",
      "Ideal para un tema o una historia completa",
    ],
    sceneName: "Escena",
    sceneFacts: [
      "Una toma animada de {n} segundos",
      "Los personajes se mueven y hablan con su propia voz",
      "Ideal para un solo momento",
    ],
    recommended: "Recomendado",
    goToScenes: "Ir a Escenas con mi idea",
    oneMoment: "Hacer solo un momento en Escenas",
    makeVideo: "Hacer el video con narrador",
    changeIdea: "Cambiar mi idea",
    cost: "Cualquiera de los dos usa uno de tus videos.",
  },
  sceneStudio: {
    seoTitle: "Escenas: una toma animada con voces",
    title: "Crea una escena",
    subtitle: "Una toma animada de {n} segundos, con sus propias voces y sonido. Lista en un minuto más o menos.",
    guide: "Di quién aparece, qué hace y qué dice. Un momento, no una historia entera.",
    lookLabel: "Estilo",
    looks: { asDescribed: "Como lo describas", animated3d: "Animación 3D", realistic: "Realista", anime: "Anime", clay: "Plastilina", cartoon: "Dibujo animado" },
    shapeLabel: "Formato",
    vertical: "Vertical 9:16",
    horizontal: "Horizontal 16:9",
    languageLabel: "Las voces hablan",
    languageHint: "Solo para los diálogos que no escribas tú.",
    cost: "Usa 1 de tus videos · {n} s · un minuto más o menos",
    costLeft: "Usa 1 de tus {left} videos · {n} s · un minuto más o menos",
    creating: "Preparando tu escena…",
    needIdea: "Primero describe el momento: con una frase basta.",
    exampleTitle: "Así es una escena",
    exampleHint: "Hecha con esta idea:",
    another: "Ver otra",
    useIdea: "Usar esta idea",
    exampleIdeas: {
      cat: "Un gato naranja salta a la mesa de la cocina y tira una taza de café. Mira a la cámara y dice: Yo no fui.",
      astronaut: "Un astronauta abre la escotilla de su nave y encuentra una playa tropical. Se quita el casco y dice: Esto no es Marte.",
      dino: "Un pequeño dinosaurio de plastilina intenta soplar las velas de su pastel de cumpleaños y no alcanza con sus bracitos. Dice: ¡Otra vez no!",
    },
    mine: "Tus escenas",
    mineEmpty: "Aquí quedan tus escenas. Cada una se puede guardar o compartir.",
    making: "Animando…",
    failed: "No se hizo",
    toVideoLead: "¿Quieres contar una historia completa, con narrador?",
    toVideo: "Crear un video",
    back: "Volver a las escenas",
  },
  sceneClip: {
    examples: [
      "Un gato naranja salta a la mesa de la cocina y tira una taza de café. Mira a la cámara y dice: Yo no fui.",
      "Un astronauta abre la escotilla de su nave y encuentra una playa tropical. Se quita el casco y dice: Esto no es Marte.",
      "Un pequeño dinosaurio de plastilina intenta soplar las velas de su pastel de cumpleaños y no alcanza con sus bracitos. Dice: ¡Otra vez no!",
    ],
    offer: {
      sceneTitle: "Esto suena a una escena",
      sceneBody: "Un video narrado hablaría de esto. Una escena lo muestra: una toma de {n} segundos, con su propio sonido y voces.",
      storyTitle: "Esto es una historia completa",
      storyBody: "Un video narrado la cuenta entera. O mira cómo empieza: una toma de {n} segundos, animada, con su propio sonido y voces.",
      makeScene: "Crear la escena de {n} segundos",
      firstScene: "Animar su primera escena",
      makeVideo: "Crear el video narrado",
      cost: "Cualquiera de los dos usa uno de tus videos.",
      blocked: {
        real_person: "No podemos mostrar a una persona real con nombre",
        religious_figure: "No podemos mostrar a una figura religiosa",
        own_picture: "No podemos usar tu propia foto ni la cara de una persona en particular",
        known_character: "No podemos usar personajes de una película, una serie, un videojuego o una marca",
        adult: "No podemos mostrar desnudos ni contenido sexual",
      },
      blockedBody: "Podemos hacer un video narrado sobre el tema. O describe un personaje inventado por ti y lo animamos.",
      change: "Cambiar mi idea",
      noCast: "Una escena todavía no usa tus personajes guardados.",
    },
    errors: {
      refused: "No pudimos hacer esta escena como la describiste, y tu video no se usó. Prueba a describirla de otra forma.",
      create: "No se pudo empezar la escena, y tu video no se usó. Inténtalo de nuevo en un momento.",
    },
    page: {
      badge: "Escena",
      making: "Animando tu escena",
      finishing: "Terminando tu escena",
      wait: "Tarda un minuto más o menos. Quédate aquí: se reproduce en cuanto esté lista.",
      ready: "Tu escena está lista",
      save: "Guardar el video en tu dispositivo",
      send: "Enviarlo a una app",
      sound: "Toca para oírlo",
      another: "Crear otra escena",
      removeWatermark: "Quitar la marca de agua",
      idea: "Tu idea",
      failedTitle: "Esta escena no se hizo",
      failed: {
        refused: "No pudimos hacer esta escena como la describiste. Prueba a describirla de otra forma.",
        timeout: "Tardó demasiado y la detuvimos.",
        error: "Algo salió mal mientras se hacía.",
        start: "Algo salió mal antes de empezar.",
      },
      givenBack: "Tu video volvió a tu cuenta: puedes usarlo otra vez.",
      tryAgain: "Probar con otra idea",
      narrated: "Hacerla como video narrado",
    },
  },
  aiAgentPage: {
    // The owner's own pictures under the idea box (components/AIAgent/IdeaImages.jsx)
    images: { add: 'Añadir imágenes', addMore: 'Añadir {{left}} más', hint: 'Hasta 3: tu producto, logo, lugar, mascota... La IA las usa en tu video.', remove: 'Quitar imagen', uploading: 'Subiendo', failed: 'No se pudo subir esta imagen', alt: 'Tu imagen {{n}}' },
    seriesNudge: {
      title: 'Ya hiciste {n} videos. ¿Hacemos de los próximos una serie?',
      text: "Videos nuevos sobre la misma idea, en el horario que elijas, y cada uno te espera para que lo veas. Empezamos por tu última idea.",
      start: 'Hacerla serie',
      close: 'Ahora no',
    },
    mode: {
      label: 'Qué hacer',
      video: 'Un video',
      series: 'Una serie',
      seriesHint: "Videos nuevos sobre esta idea, en el horario que elijas. Cada uno te espera para que lo veas antes de publicarlo.",
      plan: 'Planear mi serie',
      startFrom: 'O empieza con:',
      scene: "Una escena",
      sceneHint: "Una toma de {n} segundos con su propio sonido y voces, lista en un minuto más o menos. Usa uno de tus videos.",
      makeScene: "Crear la escena",
      scenePlaceholder: "Describe un momento: quién aparece, qué hace y qué dice…",
    },
    seoTitle: 'Generador de videos con IA: crea videos a partir de texto',
    seoDescription: 'Genera videos profesionales a partir de una idea con IA: guion, imágenes, narración y subtítulos para TikTok, Reels y YouTube Shorts en minutos.',
    title: 'Estudio del Agente de Video con IA',
    subtitle: 'Convierte tus ideas en videos cautivadores, con narración realista e imágenes de cine.',
    howItWorks: 'Mira cómo funciona',
    how: {
      title: "Cómo se hace un video",
      subtitle: "De una frase a un video narrado, en unos dos minutos.",
      idea: "Crea un video sobre la historia del café",
      generate: "Generar",
      scene: "Escena {n}",
      lines: ["En las tranquilas tierras altas de la antigua Etiopía, una simple baya empezó una historia que cambió el mundo.", "Un pastor de cabras llamado Kaldi vio a su rebaño bailar después de comer unas cerezas rojas.", "Los monjes prepararon las bayas para mantenerse despiertos en sus rezos nocturnos."],
      pictures: "Una imagen para cada momento del guion",
      voice: "Narrador",
      ready: "Listo para exportar",
      steps: {
        idea: { title: "Tu idea", body: "Basta con una frase. Elige idioma, estilo y duración si quieres." },
        script: { title: "El guion", body: "La IA escribe la historia escena por escena, con un gancho al inicio." },
        make: { title: "Imágenes y voz", body: "Cada escena recibe sus imágenes y un narrador lee el guion." },
        video: { title: "Tu video", body: "Se añaden subtítulos, música y movimiento. Edita cualquier escena y exporta." },
      },
      try: "Probar con esta idea",
      tour: "Muéstrame en la página",
    },
    exampleIdeas: [
      'Crea un documental sobre Tenochtitlan con mapa y línea de tiempo...',
      'Crea un video sobre el misterio del Triángulo de las Bermudas...',
      'Crea un video que explique el interés compuesto con gráficas...',
    ],
    prefilled: 'Tu idea ya está lista. Cambia lo que quieras y genera el video.',
    mismatch: 'Tu idea está escrita en {idea}, pero la narración está en {narration}.',
    mismatchUse: 'Narrar en {idea}',
    mismatchKeep: 'Mantener {narration}',
    stockFootage: 'Incluir imágenes de stock',
    stockFootageHint: 'Combina imágenes generadas con IA con fotos y videos reales de Pexels.',
    choices: {
      more: 'Más',
      less: 'Menos',
      cast: 'Elenco de {n}',
    },
    generate: 'Generar video',
    generating: 'Generando...',
    premium: 'Función premium',
    minutesShort: '{n} min',
    secondsShort: '{n} s',
    tryExample: 'Prueba un ejemplo:',
    visualStyle: 'Estilo visual',
    narrator: 'Narrador',
    preview: 'Escuchar a {name}',
    stop: 'Detener a {name}',
    inspired: 'Inspírate con videos creados por el Agente de IA',
    tryThis: 'Usar esta idea',
    tryShort: 'Usar',
    myProjects: 'Mis proyectos',
    myProjectsHint: 'Administra y edita los videos que generaste.',
    emptyTitle: 'Aún no tienes videos con IA',
    emptyDescription: 'Escribe una idea arriba y crea tu primer video con IA.',
    emptyCta: 'Escribe tu idea',
    ideaNeeded: 'Primero escribe tu idea: una frase sobre qué debe tratar el video. El texto gris es solo un ejemplo.',
    ideaTooShort: 'Cuéntanos un poco más: al menos una frase corta.',
    ideaPick: "O empieza con una de estas:",
    videoLink: 'Eso es el enlace de un video. Para sacarle shorts, usa Clips con IA: encuentra los mejores momentos y los encuadra por ti. El Agente de IA crea un video nuevo a partir de una idea que describes.',
    videoLinkClips: 'Hacer clips de este video',
    videoLinkAnyway: 'Crear un video sobre él de todos modos',
    useExample: 'Usar este ejemplo',
    limitTitle: 'Ya usaste todos tus videos con IA por ahora',
    limitBody: 'Usaste {used} de {limit}. Tendrás más el {date}, o mejora tu plan para crear más hoy.',
    limitBodyNoDate: 'Usaste {used} de {limit}. Mejora tu plan para crear más hoy.',
    limitTitleFree: "No te quedan videos con IA",
    limitBodyFree: "Hazte Pro, o compra 3 videos Pro con un pago único, y crea uno hoy.",
    inProgress: { title: 'Tu video todavía se está haciendo', open: 'Abrirlo' },
    limitIdeaKept: "Tu idea queda guardada en el cuadro hasta entonces.",
    limitShare: "O comparte uno de tus videos: cuando un amigo que traigas pague, recibes un video Pro.",
    limitOpenVideo: 'Tu video está listo. Ábrelo para verlo y exportarlo.',
    limitCta: 'Ver planes',
    limitWaitTitle: 'Tu video se está creando',
    limitWaitBody: 'Cuenta como uno de tus videos. Lo tendrás en tus videos cuando termine.',
    limitWaitCta: 'Sigue tu video',
    limitError: 'Llegaste al límite de videos del Agente de IA. Mejora tu plan para crear más.',
    createError: 'No pudimos crear el proyecto. Inténtalo de nuevo.',
    longer: {
      title: 'Desbloquea videos más largos',
      body: 'Un video del paquete dura hasta 3 minutos. Con Pro puedes generar videos de hasta 10 minutos.',
      cancel: 'Cancelar',
      pricing: 'Ver precios',
    },
    badges: { ai: 'Generado con IA', stock: 'Stock + IA' },
    scenarios: {
      cleopatra: { title: 'La reina Cleopatra', prompt: 'Crea un video sobre la reina Cleopatra...', subtitle: 'Historia • Documental' },
      kyoto: { title: 'El antiguo Kioto', prompt: 'Crea una guía cinematográfica de Kioto...', subtitle: 'Viajes • Cinematográfico' },
      coffee: { title: 'Historia del café', prompt: 'Crea un video sobre la historia del café...', subtitle: 'Educación • Documental' },
      texas: { title: 'Granjero de Texas, 1850', prompt: 'vlog imaginario de un granjero estadounidense de 1850...', subtitle: 'Historia • Vlog' },
      joan: { title: 'Juana de Arco', prompt: 'la historia de Juana de Arco...', subtitle: 'Historia • Documental' },
      dreams: { title: 'Los sueños', prompt: 'Crea un video sobre los sueños...', subtitle: 'Psicología • Documental' },
      history: { title: 'Historia desconocida', prompt: 'Crea un video sobre historias poco conocidas...', subtitle: 'Historia • Documental' },
    },
    tour: {
      back: 'Anterior',
      close: 'Cerrar',
      last: 'Terminar',
      next: 'Siguiente',
      skip: 'Saltar recorrido',
      ideaTitle: '¿De qué va el video?',
      ideaBody: 'Con una frase basta; el agente escribe el guion a partir de ella.',
      generateTitle: 'Un solo botón',
      generateBody: 'Tu video tarda unos minutos; te avisamos por correo cuando esté listo.',
      projectsTitle: 'Tus videos',
      projectsBody: 'Aquí se guarda cada video que haces.',
    },
  },
  // Signed-in app pages moved into the dictionary: account, results, subscription pages
  appShared: {
    projectNotFound: 'No encontramos el proyecto',
    projectNotFoundBody: 'El proyecto que buscas no existe o no tienes acceso a él.',
    backToProjects: 'Volver a los proyectos',
    errorTitle: 'Error',
    errorBody: 'Algo salió mal. Inténtalo de nuevo o contacta a soporte si el problema continúa.',
    previous: 'Anterior',
    next: 'Siguiente',
    statuses: {
      processing: 'Procesando',
      completed: 'Listo',
      failed: 'Falló',
      pending: 'En espera',
      deleted: 'Borrado',
    },
  },
  account: {
    title: 'Configuración de la cuenta',
    seoTitle: 'Configuración de la cuenta: tu perfil y tu suscripción',
    seoDescription: 'Administra tu cuenta de Clip-Short, revisa tu plan, sigue tu uso y actualiza tus datos de facturación.',
    nav: {
      profile: 'Perfil',
      subscription: 'Suscripción',
      usage: 'Uso',
      notifications: 'Notificaciones',
    },
    profile: {
      heading: 'Tu información',
      name: 'Nombre',
      email: 'Correo',
      notProvided: 'Sin datos',
    },
    notifications: {
      heading: 'Notificaciones por correo',
      intro: 'Elige qué correos quieres recibir.',
      loadError: 'No pudimos cargar tu configuración de correo.',
      tryAgain: 'Reintentar',
      saveError: 'No pudimos guardarlo. Inténtalo de nuevo.',
      transactionalLabel: 'Avisos de tus proyectos',
      transactionalDescription: 'Un correo cuando un proyecto que empezaste está listo.',
      marketingLabel: 'Novedades y ofertas',
      marketingDescription: 'De vez en cuando, novedades y ofertas de Clip-Short.',
    },
    usage: {
      heading: 'Uso',
      loadError: 'No pudimos cargar tu uso.',
      currentPeriod: 'Periodo de facturación actual',
      processingMinutes: 'Minutos de procesamiento de video',
      bundleLevel: 'Nivel de paquete {quantity}: {quantity} × {per} min = {limit} min en total',
      carried: 'Incluye {n} que pasaron del mes anterior',
      aiAgentProjects: 'Proyectos del Agente de IA',
      needMore: '¿Necesitas más? Pásate a Pro para tener límites más altos.',
      viewPricing: 'Ver precios',
      unavailable: 'No hay datos de uso disponibles.',
    },
    subscription: {
      heading: 'Detalles de la suscripción',
      refresh: 'Actualizar',
      refreshedTitle: 'Suscripción actualizada',
      refreshedBody: 'Actualizamos los datos de tu suscripción.',
      errorTitle: 'Error',
      refreshError: 'No pudimos actualizar los datos de tu suscripción.',
      portalErrorTitle: 'Error del portal',
      portalErrorBody: 'No pudimos abrir el portal para administrar tu suscripción. Inténtalo de nuevo.',
      billingMonthly: 'Facturación mensual',
      billingAnnual: 'Facturación anual',
      billingOther: 'Facturación: {period}',
      billingUnavailable: 'Periodo de facturación no disponible',
      statuses: {
        active: 'Activa',
        trialing: 'Prueba gratis',
        canceled: 'Cancelada',
        past_due: 'Pago vencido',
        incomplete: 'Incompleta',
        unpaid: 'Sin pagar',
      },
      trialTitle: 'Prueba gratis activa',
      trialEndsBefore: 'Tu prueba gratis de 7 días termina el',
      trialEndsAfter: '.',
      trialNoCharge: 'No te cobraremos nada hasta entonces. Cancela cuando quieras antes de que termine la prueba y no pagarás nada.',
      legacyTitle: 'Plan anterior',
      legacyBody: 'Tienes un plan anterior que ya no está disponible para clientes nuevos.',
      legacyKeep: 'Puedes conservar tu precio y tus límites actuales, o cambiarte cuando quieras a nuestro nuevo plan Pro flexible.',
      legacyBadge: 'Anterior',
      trialLength: 'Prueba gratis de 7 días',
      bundles: '{count} paquetes',
      bundleIncludes: '({hours} h de procesamiento + {videos} videos con IA)',
      trialBadge: 'Prueba',
      cancelPendingTitle: 'Cancelación pendiente',
      cancelPendingBody: 'Tu suscripción termina el {date}. Después de esa fecha pierdes el acceso a las funciones Pro.',
      limitProcessing: 'Procesamiento',
      limitAiVideos: 'Videos con IA',
      limitReprompts: 'Nuevas búsquedas',
      trialEnds: 'La prueba termina',
      periodEnds: 'El periodo actual termina',
      status: 'Estado',
      noRenew: 'La suscripción no se renovará automáticamente.',
      cancelsAtEnd: 'Se cancela al final del periodo',
      freeTrial: 'Prueba gratis',
      openingPortal: 'Abriendo el portal...',
      manage: 'Administrar suscripción',
      noneTitle: 'No tienes una suscripción activa',
      noneBody: 'Pásate a un plan Pro para usar las funciones premium y tener límites de uso más altos.',
      viewPlans: 'Ver planes',
    },
  },
  captionsResult: {
    back: 'Volver a los proyectos de subtítulos',
    exportJson: 'Exportar JSON',
    exportJsonHint: 'Descargar la transcripción en JSON',
    starting: 'Empezando a generar el video...',
    startFailed: 'No pudimos empezar a generar el video',
    timedOut: 'La generación del video tardó demasiado',
    complete: '¡Video listo!',
    failed: 'No se pudo generar el video',
    rendering: 'Generando el video con subtítulos...',
    checkFailed: 'No pudimos revisar el estado del video',
    wordsHeard: '{n} palabras detectadas',
    livePreview: 'Vista previa en vivo',
    rendered: 'Video final',
    custom: 'Personalizado',
    transcriptPane: 'Transcripción',
    previewPane: 'Vista previa',
    settingsPane: 'Configuración de los subtítulos',
    noVideo: 'El video no está disponible para la vista previa.',
    renderingShort: 'Generando…',
    renderAgain: 'Generar de nuevo',
    burnIn: 'Grabar los subtítulos',
    videoButton: "Descargar video",
    transcriptButton: 'Transcripción',
    openEditor: 'Abrir en el editor completo',
  },
  captionControls: {
    fontSize: 'Fuente y tamaño',
    fontPlaceholder: 'Fuente...',
    size: 'Tamaño',
    sizeAria: 'Tamaño de la fuente',
    wordGrouping: 'Agrupar palabras',
    casePlaceholder: 'Mayúsculas...',
    outline: 'Contorno',
    outlineAria: 'Contorno del texto',
    shadow: 'Sombra',
    shadowAria: 'Intensidad de la sombra',
    textAppearance: 'Aspecto del texto',
    glitch: 'Efecto glitch',
    glitchIntensity: 'Intensidad del glitch ({n}%)',
    glitchHint: 'Ajusta la intensidad del efecto glitch',
    glitchAria: 'Intensidad del glitch',
    glitchStroke: 'Color del contorno (para el glitch)',
    captionBackground: 'Fondo de los subtítulos',
    speakerColors: 'Un color para cada persona',
    backgroundColor: 'Color de fondo',
    opacity: 'Opacidad ({n}%)',
    opacityAria: 'Opacidad del fondo',
    animationPlaceholder: 'Elige una animación...',
    animation: 'Animación',
    verticalPosition: 'Posición vertical',
    textColor: 'Color del texto',
    highlightColor: 'Color de resaltado',
    cases: {
      uppercase: 'MAYÚSCULAS',
      lowercase: 'minúsculas',
      capitalize: 'Primera Mayúscula',
      normal: 'Normal',
    },
    animations: {
      tiktok: 'Estilo TikTok',
      fade: 'Aparecer',
      slide: 'Deslizar hacia arriba',
      pop: 'Pop',
      glitch: 'Glitch',
    },
  },
  reframeResult: {
    analysing: 'Calculando el encuadre para {aspect}…',
    analysisFailed: 'Falló el análisis del encuadre.',
    liveFramed: 'Esto es en vivo, con tu encuadre. Al generar el video obtienes exactamente esto.',
    live: 'Esto es en vivo. Solo necesitas generar el video para descargar un archivo.',
    waiting: 'Elige un formato para verlo, o genera uno para descargarlo.',
    previewPane: 'Vista previa',
    sourcePane: 'Original',
    resultPane: 'Reencuadrado',
    settingsPane: 'Configuración del reencuadre',
    madeBlack: 'barras negras donde un plano no alcanza',
    madeBlur: 'relleno desenfocado donde un plano no alcanza',
    noSource: 'El video original no está disponible.',
    sourceCaption: 'El video que subiste',
    liveCaption: '{aspect} · vista previa en vivo',
    resultCaption: 'Reencuadrado a {aspect}',
    shape: 'Formato',
    adjustFraming: 'Ajustar el encuadre',
    paddingLabel: 'Cuando un plano no llena el cuadro',
    paddingUnused: 'No se usa: tú definiste el encuadre, así que el archivo sale exactamente como en la vista previa.',
    paddingHint: 'El desenfoque llena los bordes con el mismo plano; el negro deja barras.',
    reframeTo: 'Reencuadrar a {aspect}',
    renderFramed: 'Generar con tu encuadre',
    reframeAgain: 'Reencuadrar de nuevo',
    upToDate: "Este es el archivo que ya tienes. Cambia la forma o el encuadre para hacer otro.",
    download: 'Descargar',
  },
  subscriptionResult: {
    backToVideo: 'Volver a tu video',
    backToWork: 'Volver a donde estabas',
    watermarkNext: 'Exporta tu video de nuevo: sale sin marca de agua.',
    successSeoTitle: 'Suscripción activada',
    successSeoDescription: 'Tu suscripción a Clip-Short está activa. Empieza hoy a crear videos cortos profesionales.',
    noSession: 'No encontramos el ID de la sesión en el enlace',
    notFound: 'No encontramos la suscripción. Puede tardar unos momentos en procesarse.',
    verifySubscriptionError: 'Error al verificar la suscripción: {message}',
    verifyPaymentError: 'Error al verificar el pago: {message}',
    unlimited: 'Ilimitadas',
    processingTitle: 'Procesando tu suscripción',
    processingBody: 'Espera un momento mientras confirmamos tu pago...',
    verificationTitle: 'Verificación de la suscripción',
    verificationError: 'Error de verificación',
    backToPricing: 'Volver a los precios',
    trialStarted: '¡Empezó tu prueba gratis!',
    welcome: 'Te damos la bienvenida a {plan}',
    trialAccessTitle: '7 días con acceso completo',
    trialAccessBefore: 'Tienes acceso completo a todas las funciones de {plan} hasta el',
    trialAccessAfter: '.',
    trialNoCharge: 'No te cobraremos nada hasta que termine tu prueba. Cancela cuando quieras antes y no pagarás nada.',
    includedTitle: 'Lo que incluye tu prueba:',
    processingHours: '{hours} horas de procesamiento de video al mes',
    clippingOne: 'Clips con IA de videos largos ({n} nueva búsqueda)',
    clippingMany: 'Clips con IA de videos largos ({n} nuevas búsquedas)',
    captioning: 'Subtítulos automáticos',
    reframing: 'Reencuadre de videos a 9:16, 1:1, 4:5 o 16:9',
    editorRenders: 'Exportación de proyectos del editor',
    aiVideos: '{n} videos del Agente de IA al mes',
    imageRegenerations: '{n} regeneraciones de imagen por proyecto',
    imageEdits: '{n} ediciones de imagen por proyecto',
    animations: '{n} animaciones de imagen a video por proyecto',
    voiceRegenerations: '{n} regeneraciones de voz por proyecto',
    noWatermark: 'Sin marca de agua en tus videos',
    editorAccess: 'Acceso al editor de video',
    support: 'Soporte prioritario por correo',
    firstProject: 'Crea tu primer proyecto',
    viewAccount: 'Ver mi cuenta',
    activated: '¡Suscripción activada!',
    startCreating: 'Empezar a crear',
    cancelSeoTitle: "Pago sin terminar",
    cancelSeoDescription: "Saliste del pago antes de pagar. No se hizo ningún cargo. Vuelve a los precios para ver nuestros planes.",
    cancelTitle: "Pago sin terminar",
    cancelAlertTitle: "No se hizo ningún cargo",
    cancelBody: "Saliste del pago antes de pagar. No se hizo ningún cargo.",
    returnToPricing: 'Volver a los precios',
    goToAccount: 'Ir a mi cuenta',
    backToMyVideo: "Volver a mi video",
  },
  projectTimeline: {
    unknown: 'Desconocido',
    recent: 'Creado hace poco',
    aspectRatio: 'Formato: {value}',
    padding: 'Relleno: {value}',
    complete: '{n}% listo',
  },
  projectPage: {
    captionsSeoTitle: '{title} - Proyecto de subtítulos',
    captionsSeoFallback: 'Detalles del proyecto de subtítulos',
    captionsSeoDescription: 'Mira y edita los subtítulos de tu video. Personaliza su estilo, descarga el video subtitulado y administra tu proyecto de transcripción.',
    seoTitle: '{title} - Detalles del proyecto',
    reframeSeoFallback: 'Detalles del proyecto de reencuadre',
    seoFallback: 'Detalles del proyecto',
    reframeSeoDescription: 'Mira y descarga tu video reencuadrado. Sigue el progreso del cambio de formato y administra tu proyecto de reencuadre.',
    clippingSeoDescription: 'Mira y administra tu proyecto de clips con IA. Sigue el progreso, revisa los momentos virales encontrados y descarga tus videos cortos.',
    reprompt: 'Buscar de nuevo',
    premium: 'Premium',
    promptFoundNothing: 'El encargo {n} (“{prompt}”) no encontró clips. Inténtalo de nuevo con otra instrucción.',
    repromptTab: 'Búsqueda #{n}',
    repromptProcessing: 'Procesando la nueva búsqueda...',
    customPrompt: 'Instrucción personalizada:',
    repromptFailed: 'Falló la nueva búsqueda',
    repromptFailedBody: 'Lo sentimos, la nueva búsqueda falló. Puedes intentarlo de nuevo con otra instrucción.',
  },
  newProject: {
    unreadableLink: 'No pudimos leer este enlace. Revisa que el video sea público, o prueba con un enlace de YouTube, Twitch, Kick, Drive o X.',
    channelLink: "Ese es el enlace de un canal o una lista. Pega el enlace de un video de ahí.",
    noLinkInText: "Ese texto no tiene un enlace de video. Pega el enlace de un video.",
    twitchNotLive: "Ese canal de Twitch no está en directo ahora. Pega el enlace de una transmisión pasada (un VOD).",
    videoUnavailable: "Este video es privado, se borró o está bloqueado en algunos países. Prueba otro enlace o sube el archivo.",
    noSourceYet: 'Agrega un video (enlace o archivo) y espera a que carguen sus datos.',
    noDuration: 'No pudimos saber cuánto dura el video. Prueba con otro video.',
    reframeTooLong: 'El reencuadre procesa hasta 30 minutos por vez. Elige una parte de 30 minutos o menos.',
    partTooShort: 'Los clips con IA necesitan al menos 5 minutos para encontrar clips. Elige una parte más larga.',
    videoTooShort: 'Tu video dura menos de 5 minutos. Elige un video más largo para generar clips.',
    noFile: 'Error interno: se eligió un archivo, pero no hay ninguno.',
    uploadInProgress: 'Espera a que termine de subirse el archivo.',
    uploadFirst: 'Sube el archivo elegido antes de crear el proyecto.',
    notAVideo: 'Tipo de archivo no válido. Elige un archivo de video.',
    invalidUrl: 'Escribe un enlace de video válido.',
    infoNotReady: 'Todavía no tenemos los datos del video. Espera un momento o revisa el enlace.',
    noSource: 'Agrega un video.',
    metadataFailed: 'No pudimos leer los datos del archivo elegido. Prueba con otro archivo.',
    selectFileFirst: 'Primero elige un archivo.',
    uploadFailed: 'No se pudo subir el archivo. Inténtalo de nuevo.',
    uploaded: 'Archivo subido',
    reframeDemoTop: 'La IA mantiene al protagonista en cuadro, plano por plano.',
    reframeDemoBottom: 'Vertical, cuadrado o ancho. Sin franjas negras.',
  },
  remixStickers: {
    change: 'Cambiar sticker ({label})',
    remove: 'Quitar sticker ({label})',
  },
  notFoundPage: {
    title: 'Página no encontrada',
    text: 'Esta página no existe o cambió de lugar. Esto es lo que la mayoría busca:',
    home: 'Inicio',
    aiAgent: 'Crea un video a partir de una idea',
    tools: 'Verificador de monetización de YouTube gratis',
    pricing: 'Precios',
  },
  affiliates: {
    page: {
      seoTitle: 'Programa de afiliados: 30% de cada pago',
      seoDescription: 'Gana el 30% de cada pago de los creadores que traigas a Clip-Short, mientras sigan suscritos. Pagos mensuales por PayPal, Wise o Vodafone Cash.',
      badge: 'Programa de afiliados',
      title: 'Gana el 30% de cada pago, mientras sigan suscritos',
      subtitle: 'Comparte Clip-Short con los creadores que te siguen. Cuando alguien se registra con tu enlace y se suscribe, te llevas el 30% de todo lo que paga, cada mes que siga pagando.',
      join: 'Hazte afiliado',
      facts: {
        rate: '30% de cada pago',
        link: 'Enlace válido 60 días',
        payout: 'Pagos mensuales',
      },
      stepsTitle: 'Cómo funciona',
      steps: {
        link: { title: 'Consigue tu enlace', text: 'Únete desde tu cuenta en un minuto. Tu enlace lleva tu propio código, por ejemplo clip-short.com/?via=tunombre.' },
        share: { title: 'Compártelo', text: 'Ponlo en la descripción de tus videos, en tu bio, en tus publicaciones o en tu grupo. Quien lo abra y se registre en los siguientes 60 días cuenta como tuyo.' },
        paid: { title: 'Cobra cada mes', text: 'Ganas el 30% de cada pago que hagan. Cuando tu saldo confirmado pasa de US$20, te lo enviamos por PayPal, Wise o Vodafone Cash.' },
      },
      termsTitle: 'Las condiciones, claras',
      terms: [
        'El 30% de cada pago que haga un cliente que traigas, después de cualquier descuento, mientras siga suscrito.',
        'Tu enlace cuenta durante 60 días desde su primera visita. Si antes llegó por el enlace de otro afiliado, gana el primer enlace.',
        'Una comisión se confirma 30 días después del pago, cuando ya no se puede reembolsar. Un pago reembolsado no genera nada.',
        'Pagamos las comisiones confirmadas una vez al mes, por PayPal, Wise o Vodafone Cash, cuando suman US$20. Lo que falte pasa al mes siguiente.',
        'Solo cuentan cuentas nuevas: quien ya tenía cuenta o ya pagaba no es un referido, y nadie puede referirse a sí mismo.',
      ],
      rulesTitle: 'No está permitido',
      rules: [
        'Anuncios pagados con nuestro nombre: no pujes por “Clip-Short” ni por sus variantes en Google, YouTube ni ninguna otra plataforma de anuncios.',
        'Spam: nada de mensajes, correos o comentarios no solicitados, ni publicar tu enlace donde no es bienvenido.',
        'Promesas que no hacemos: nada de reseñas falsas, descuentos inventados ni afirmaciones sobre Clip-Short que no sean ciertas.',
      ],
      rulesNote: 'Si un afiliado rompe estas reglas, pausamos su enlace y deja de generar comisiones.',
      faqTitle: 'Preguntas',
      faq: {
        who: { q: '¿Quién puede unirse?', a: 'Cualquier persona con una cuenta de Clip-Short. No necesitas ser cliente de pago y no hay un mínimo de seguidores.' },
        track: { q: '¿Cómo saben que alguien llegó por mí?', a: 'Tu enlace lleva tu código. Su navegador lo guarda durante 60 días y se asocia a esa persona cuando crea su cuenta. En tu panel ves las visitas, los registros y cada comisión.' },
        when: { q: '¿Cuándo cobro?', a: 'Cada comisión se confirma 30 días después del pago. Una vez al mes enviamos todo lo confirmado, siempre que sume al menos US$20.' },
        how: { q: '¿Cómo me envían el dinero?', a: 'Por PayPal, Wise o Vodafone Cash, a la cuenta que nos indiques. Puedes cambiarla cuando quieras en tu panel.' },
        refund: { q: '¿Qué pasa si un cliente pide un reembolso?', a: 'Un pago reembolsado no genera comisión. Por eso las comisiones se confirman después de 30 días.' },
        life: { q: '¿De verdad es mientras sigan suscritos?', a: 'Sí. Cada renovación mensual o anual de un cliente que trajiste te da otra vez el 30%, mientras siga pagando y el programa exista.' },
      },
      ctaTitle: '¿Listo para compartir Clip-Short?',
      ctaText: 'Conseguir tu enlace toma un minuto.',
    },
    dashboard: {
      nav: 'Afiliados',
      heading: 'Programa de afiliados',
      intro: 'Gana el 30% de cada pago de las personas que traigas, mientras sigan suscritas.',
      readTerms: 'Ver las condiciones',
      joinTitle: '¿A dónde te enviamos el dinero?',
      method: 'Método de pago',
      methods: {
        paypal: 'PayPal',
        wise: 'Wise',
        vodafone_cash: 'Vodafone Cash',
        other: 'Otro',
      },
      details: {
        paypal: 'Tu correo de PayPal',
        wise: 'Tu correo de Wise',
        vodafone_cash: 'Tu número de Vodafone Cash',
        other: '¿Cómo te pagamos?',
      },
      placeholders: {
        paypal: 'tu@correo.com',
        wise: 'tu@correo.com',
        vodafone_cash: '010 1234 5678',
        other: 'La cuenta y lo que necesitemos para enviarlo',
      },
      agree: 'Al unirte aceptas las condiciones del programa: nada de anuncios pagados con nuestro nombre y nada de spam.',
      join: 'Obtener mi enlace',
      joining: 'Uniéndote…',
      errors: {
        invalid_payout_details: 'Eso no parece correcto para este método de pago. Revísalo e inténtalo de nuevo.',
        invalid_payout_method: 'Elige cómo quieres cobrar.',
        generic: 'Algo salió mal. Inténtalo de nuevo.',
      },
      loadError: 'No pudimos cargar tu cuenta de afiliado.',
      tryAgain: 'Reintentar',
      yourLink: 'Tu enlace',
      linkHint: 'También funciona si añades ?via={code} a cualquier página de clip-short.com.',
      copy: 'Copiar',
      copied: 'Copiado',
      clicks: 'Visitas',
      signups: 'Registros',
      customers: 'Clientes de pago',
      pending: 'Pendiente',
      pendingHint: 'Se confirma 30 días después de cada pago',
      approved: 'Confirmado',
      approvedHint: 'Se paga cada mes desde US$20',
      paid: 'Pagado a ti',
      noMoney: 'Todavía nada. Una comisión aparece aquí en cuanto paga un cliente que trajiste.',
      recentTitle: 'Comisiones',
      columns: {
        date: 'Pago',
        amount: 'Pagó',
        commission: 'Ganas',
        status: 'Estado',
      },
      statuses: {
        pending: 'Pendiente hasta el {date}',
        approved: 'Confirmada',
        paid: 'Pagada',
        void: 'Reembolsada',
      },
      payoutTitle: 'Datos de pago',
      change: 'Cambiar',
      save: 'Guardar',
      saving: 'Guardando…',
      cancel: 'Cancelar',
      paused: 'Tu enlace está en pausa: no trae clientes nuevos ni genera comisiones nuevas. Escríbenos si crees que es un error.',
    },
  },
  renderStage: {
    preparing: 'Preparando tu video…',
    scene: 'Preparando la escena {n} de {total}…',
    clip: 'Preparando el clip {n} de {total}…',
    frames: 'Creando tu video · {percent}%',
    finishing: 'Dando los últimos toques…',
    saving: 'Guardando tu video · {percent}%',
    done: 'Listo',
  },
};
